import { Component, OnInit, ViewChild, ViewChildren, ChangeDetectorRef, ElementRef } from '@angular/core';
import { User } from '../_models/user';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from "angularx-social-login";
import { saveAs } from 'file-saver';
import { Title, Meta } from '@angular/platform-browser';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthenticationService } from '../authentication.service';
import { DamserviceService } from "../dam/damservice.service";
import { InboxservicesService } from "../inboxarea/inboxservices.service";
import { UploadFilesService } from 'src/app/services/upload-files.service';
import { OrganisationService } from "../create-organisation/organisation.service";
import { HttpEventType, HttpResponse } from '@angular/common/http';
import { AlertService } from "../components/alert/alert.service";
import { SubscriptionService } from "../subscription/subscription.service";
import { FormBuilder, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { PdfViewerComponent } from 'ng2-pdf-viewer';
import { GoogleAnalyticsService } from '../google-analytics.service';
import AOS from 'aos';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-boarddata',
  templateUrl: './boarddata.component.html',
  styleUrls: ['./boarddata.component.css'],
})
export class BoarddataComponent implements OnInit {

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private modalService: NgbModal,
    private authenticationService: AuthenticationService,
    private uploadService: UploadFilesService,
    private damService: DamserviceService,
    private inboxService: InboxservicesService,
    private organisationService: OrganisationService,
    private titleService: Title,
    private metaTagService: Meta,
    private alert: AlertService,
    private subscriptionService: SubscriptionService,
    private changeDetection: ChangeDetectorRef,
    private fb: FormBuilder,
    private http: HttpClient,
    private googleAnalyticsService: GoogleAnalyticsService,
    private sanitizer: DomSanitizer
  ) { }

  boards = [];
  moveBoards = [];
  moveBoardId: any;
  searchedBoards = [];
  imagesExtension: [];
  workspaces = [];
  fileInfos: [];
  figmaLinksList: [];
  uploadedFileName: string;
  imagesList = [];
  boardIdsList = [];
  asssetsIdsList = [];
  searchText: string = '';
  searchTerms: string[] = [];
  boardHeadingEdit: string = '';
  boardSearchKeyword: string;
  showSearchBoardList: boolean = false;
  showSearchBoardOlderList: boolean = true;
  imageNameEdit: string = '';
  favImageNameEdit: string = '';
  searchData: string = '';
  userPic: any;
  workspaceId: any
  workspaceName: string;
  boardId: any;
  newBoardIdAfterDelete: any;
  newBoardNameAfterDelete: any;
  boardName: string;
  totalIllusCount: any;
  planName: string;
  ownerEmail: string;
  ownerName: string;
  totalSpaceAllowed: any;
  consumedSpaceAllowed: any;
  totalSpaceAllowedProgress: any;
  changeColor= [false, false, false];
  imagesIdList: Array<{id: any, title: string}> = [];
  imagesIds: Array<{id: any}> = [];
  imagesUrls: Array<{url: any}> = [];
  openBoardList: boolean = false;
  moveImageId:any;
  addedTagList: Array<{tags: string}> = [];
  addedUrlsTagList: Array<{tags: string}> = [];
  addTagText: string = '';
  addUrlsTagText: string = '';
  addedTag:string;
  addedUrlsTag:string;
  checkedId = -1;
  count: number = 0;
  fileText: string;
  currentUser: User;
  uploadVersionStyle = "none";
  deleteBoardStyle = "none";
  deleteProcessStyle = "none";
  verifyBoardStyle = "none";
  moveImagesStyle = "none";
  downloadImagesStyle = "none";
  imageDeleteProcessStyle = "none";
  shareLinkStyle = "none";
  shareFigmaLinkStyle = "none";
  deleteBoardId: any;
  deleteBoardName: string;
  downloadBoardName: string;
  shareStyle = "none";
  uploadOptionsStyle = "none";
  currentIllus: any;
  currentUrlsIllus: any;
  selectedVersion: any;
  currentUrlsIllusPosition: any;
  currentIllusPosition: any;
  currentSearchIllusPosition: any;
  currentAssetId: any;
  currentUrlsAssetId: any;
  boardHeading: string = '';
  imageUrlsHeading: string = '';
  boardname: string = '';
  currentBoard: any;
  userRole: string;
  selectedFiles: FileList;
  progressInfos = [];
  progressPecentage: any;
  message = '';
  editImageNameBoardId: any;
  showEditBoardName: boolean = false;
  hideEditBoardName: boolean = true;
  showEditImageName: boolean = false;
  hideEditImageName: boolean = true;
  showEditFavImageName: boolean = false;
  hideEditFavImageName: boolean = true;
  imageHeading: string = '';
  favImageHeading: string = '';
  isFav: boolean = false;
  showUrlsEditImageName: boolean = false;
  showRenameFormatAdd: boolean = false;
  showSearchNextIcon: boolean = true;
  showSearchPreviosIcon: boolean = true;
  showNextIcon: boolean = true;
  showPreviosIcon: boolean = true;
  showUrlsNextIcon: boolean = true;
  showUrlsPreviosIcon: boolean = true;
  boardCreateErrorMessage: String;
  sendSuccessfulErrorMsg: boolean = false;
  sendSuccessfulErrorMessage: string;
  sendSuccessfulToastMsg: boolean = false;
  sendSuccessfulToastMessage: string;
  isShowError:boolean = false;
  public keepBoth: boolean = false;
  public replaceAsset: boolean = true;
  isShowShareLinkGenerated: boolean = true;
  isHideShareLinkGenerated: boolean = false;
  isShowLoadingStatus: boolean = false;
  isShowLoadingStatusDone: boolean = false;
  showLinkCopied: boolean = false;
  showChatLoader: boolean = false;
  addingFigmaLinkLoader: boolean = false;
  notifications = [];
  date: string;
  dateValue: [];
  notificationMsg: string;
  showLoader: boolean = false;
  sendSuccessful: boolean = false;
  successfullMessage: string;
  moveFromSearch: any;
  moveFromBoardId: any;
  renameErrorMsg: string;
  renameFigmaErrorMsg: string;
  shareableLink: string;
  shareImageLink: any;
  renameImageLink: any;
  editTagsImageLink: any;
  editTagsImageFormats: any;
  editTagsName: any;
  editTagsList: string[] = [];
  assetEditTagsStyle = "none";
  showEditTagsLoader: boolean = false;
  editTagsError: any;
  figmaAddLink: string = '';
  figmaErrorMsg: string;
  invalid: boolean = true
  commentId: any;
  commentMsg: any;
  replyMsg: any;
  editComment: any;
  commentsList = [];
  suggestedTags = [];
  urlsSuggestedTags = [];
  imageFormats = [];
  noComments: any;

  figmaBoardId: any;
  figmaNewName: any;
  figmaCurrentName: any;
  figmaId: any
  figmaRenameStyle = "none";

  url: any;
  format: any;

  mobileView: boolean = false;
  plusButton: boolean = true;
  tagFieldArea: boolean = false;
  imageSelected:boolean = false;
  searchTextSet: any;
  downloadDelete:boolean = false;
  hideDialogSection: boolean = true;
  searchImageslistSection: boolean = false;
  boardImagesSection: boolean = true;
  shimmerSection: boolean = true;
  workspaceCountAllowed: any;
  totalWorkspaceCreated: any
  planId: any;
  showLeaveLoader: boolean = false;
  showDeleteLeaveLoader: boolean = false;
  showTopRightLoader: boolean = false;
  showLoaderBoardsList: boolean = false;
  showDownloadLoader: boolean = false;
  showZipDownloadLoader: boolean = false;
  showMainDownloadLoader: boolean = false;
  openEditBox: boolean = false;
  showDownloadDialog: boolean = false;
  showUsersListDialog: boolean = false;
  showUsersListReplyDialog: boolean = false;
  userSelectedForTag: boolean = false;
  userSelectedForReplyTag: boolean = false;
  selectedUserIdForTag: any;
  selectedUserNameForTag: any;
  imageDownloadFormat: any;
  imageDownloadShowFormat: any;
  showSmallImg: boolean = false;
  public textArea: string = '';
  public replyArea: string = '';
  usersList = [];

  public selectedIndex;
  public selectedFormatIndex;

  public index;

  public selectedImageNumber;

  width: any;
  height: any;

  sharedToken: any;
  fromAssets: boolean = false;
  allowDownloads: any;
  showComments: any;
  allowComments: any;
  allowDownloadSelected: boolean = true;
  showCommentSelected: boolean = false;
  allowCommentingSelected: boolean = false;
  expiryLinkIn: any = "f";

  mainComponent: any;
  fromSectionName: any;
  assetRenameStyle = "none";
  boardRenameStyle = "none";
  assetCurrentId: any;
  assetCurrentName: any;
  boardCurrentName: any;
  assetBoardId: any;
  assetNewName: any;
  boardNewName: any;
  renameBoardId: any;
  showRenameLoader: boolean = false;
  editNameBoardId: any;

  showtableViewData: boolean = false;
  showKanbanView: boolean = false;
  showNestedViewData: boolean = true;
  isTableSelected: boolean = false;
  isNestedSelected: boolean = true;
  isKanbanSelected: boolean = false;

  createPrivateSharedWorkspaceStyle = "none";
  createWorkspaceStyle = "none";
  isShowCreateWorkspaceError: boolean = false
  createWorkspaceErrorMessage: string;
  isShowCreateLoginWorkspaceError: boolean = false
  createWorkspaceLoginErrorMessage: string;

  creatwWorkspace = this.fb.group({
    message: ['', Validators.required],
  });

  @ViewChild('imgMainModal') imgMainModal;
  @ViewChild('imgUrlsModal') imgUrlsModal;
  @ViewChild('imgSearchModal') imgSearchModal;
  @ViewChild('shareModal') shareModal;
  @ViewChildren("checkboxes") checkboxes;

  commentForm = this.fb.group({
    comment: ['', Validators.required],
  });

  replyForm = this.fb.group({
    replyMessage: ['', Validators.required],
  });

  mainMsgForm = this.fb.group({
    mainmessage: ['', Validators.required],
  });

  tagsForm = this.fb.group({
    edittags: ['', Validators.required],
  });

  submitted: Boolean = false;

  ngOnInit(): void {
    this.metaTagService.addTags([
      { name: 'description', content: 'Crafttor Workspace provides you with number of boards you created and upload images to your boards keeping it secure and smooth to access images anytime.'},
      { name: 'keywords', content: 'boards, board, workspace, upload free illustrations, upload clean pixel illustrations, upload premium illustration, ' },
      { name: 'robots', content: 'index, follow' },
      { name: 'author', content: 'Crafttor' },
      { name: 'viewport', content: 'width=device-width, initial-scale=1' },
      { charset: 'UTF-8' }
    ]);

    AOS.init();

    this.authenticationService.currentUser.subscribe(x => { this.currentUser = x });
    if (window.screen.width <= 991) { // 768px portrait
      this.mobileView = true;
    }else{
      this.mobileView = false;
    }

    var details = JSON.parse(localStorage.getItem('workspaceDetails'));
    this.workspaceId = details.workspaceId;
    this.workspaceName = details.workspaceName;
    this.route.paramMap.subscribe(params => {
      this.boardId = params.get('boardId');
      this.boardHeading = this.boardId;
      this.boardname = this.boardId;
      this.titleService.setTitle(this.boardHeading + " | Workspace | Crafttor");
      if (this.currentUser) {
        this.getWorkspaceDetails();
        this.getUserPic();
        this.getFavImagesList();
      } else {
        this.router.navigate(['/login']);
      }
    // this.listWorkspace();
    });

    // this.suggestedTags.push("3D");
    // this.suggestedTags.push("illustration");
    // this.suggestedTags.push("vector");
    // this.suggestedTags.push("woman");
    // this.suggestedTags.push("man");
    // this.suggestedTags.push("product");
    // this.suggestedTags.push("laptop");
    // this.suggestedTags.push("mobile");

    this.urlsSuggestedTags.push("figma");
    this.urlsSuggestedTags.push("design");
    this.urlsSuggestedTags.push("file");
    this.urlsSuggestedTags.push("ai");
    this.urlsSuggestedTags.push("doc");
    this.urlsSuggestedTags.push("illustrator");
    this.urlsSuggestedTags.push("sketch");
    this.urlsSuggestedTags.push("url");
    this.urlsSuggestedTags.push("adobe");

    // this.imageFormats.push("SVG");
    this.imageFormats.push("PNG");
    this.imageFormats.push("JPEG");
    // this.imageFormats.push("gif");
    // this.imageFormats.push("raw");
    this.imageFormats.push("TIFF");
    this.imageFormats.push("WEBP");

    this.searchTerms = [];

    const savedSize = localStorage.getItem('imageSize');
    this.selectedSize = savedSize ? savedSize : 'medium';
  }

  getWorkspaceDetails(){
    var details = JSON.parse(localStorage.getItem('workspaceDetails'));
    var boardDetails = JSON.parse(localStorage.getItem('boardDetails'));
    this.moveBoardId = boardDetails.boardId;
    this.workspaceId = details.workspaceId;
    this.workspaceName = details.workspaceName;
    this.getCurrentUserData(this.workspaceId);
    this.boardId = boardDetails.boardId;
    this.index = boardDetails.boardIndex;
  }

  getUserPic() {
    this.damService.getUserPic().subscribe((data: any) => {
      this.userPic = data.user_pic;
    });
  }

  listWorkspace(){
    if (this.currentUser) {
      this.organisationService.getWorkspaceList().subscribe((data: any) => {
        if(data.length > 0){
          this.workspaces = data;
          this.ownerListApi();
          this.getImagesList(this.boardId);
        }else{
            this.router.navigate(['/create-workspace']);
          }
      });
    }else{
        this.router.navigate(['/login']);
    }
  }

  getCurrentUserData(workspaceId: any) {
    this.showTopRightLoader = true;
    this.damService.getCurrentUserData(workspaceId).subscribe((data: any) => {
      this.userRole = data.role;
      this.listWorkspace();
      this.getBoardsList();
    },
    (error) => {
      if (this.currentUser) {
        if(error.status == 500){
          // this.router.navigate(['/maintenance']);
        } else {

        }
      } else {
        this.router.navigate(['/login']);
      }
  });
  }

  selectWorkspace(id: any, title: string, userRole: string){
    this.workspaceName = title;
    this.workspaceId = id;
    this.getCurrentUserData(this.workspaceId);
    localStorage.setItem('workspaceDetails', JSON.stringify({ workspaceId: id,
      workspaceName: title, userRole: userRole }));
    this.router.navigate(['/dam']);
  }

  mainClick(){
    localStorage.setItem('workspaceDetails', JSON.stringify({ workspaceId: this.workspaceId,
      workspaceName: this.workspaceName, userRole: this.userRole }));
    this.router.navigate(['/dam']);
  }

  peopleClick(){
    localStorage.setItem('workspaceDetails', JSON.stringify({ workspaceId: this.workspaceId,
      workspaceName: this.workspaceName, userRole: this.userRole }));
    this.router.navigate(['/dam/people']);
  }

  personalClick(){
    localStorage.setItem('workspaceDetails', JSON.stringify({ workspaceId: this.workspaceId,
      workspaceName: this.workspaceName, userRole: this.userRole }));
    this.router.navigate(['/dam/personal']);
  }

  newBoardClick(){
    localStorage.setItem('workspaceDetails', JSON.stringify({ workspaceId: this.workspaceId,
      workspaceName: this.workspaceName, userRole: this.userRole }));
    this.router.navigate(['/dam/create-board']);
  }

  archiveClick() {
    localStorage.setItem('workspaceDetails', JSON.stringify({ workspaceId: this.workspaceId,
      workspaceName: this.workspaceName, userRole: this.userRole }));
    this.router.navigate(['dam/trash']);
  }

  inboxClick(){
    localStorage.setItem('workspaceDetails', JSON.stringify({ workspaceId: this.workspaceId,
      workspaceName: this.workspaceName, userRole: this.userRole }));
    this.router.navigate(['dam/inbox']);
  }

  settingsClick(){
    localStorage.setItem('workspaceDetails', JSON.stringify({ workspaceId: this.workspaceId,
      workspaceName: this.workspaceName, userRole: this.userRole }));
    this.router.navigate(['/dam/settings']);
  }

  editBoardClickNew(boardTitle: string, boardId: any){
    localStorage.setItem('editBoardDetails', JSON.stringify({ boardId: boardId, boardTitle: boardTitle}));
    this.router.navigate(['/dam/edit-board']);
  }

  editBoardClick(boardTitle: string, boardId: any){
    this.selectedIndex = -1;
    this.boardname = boardTitle;
    this.boardId = boardId;
  }

  editBoardName(){
    this.hideEditBoardName = false;
    this.showEditBoardName = true;
    this.boardHeadingEdit = this.boardHeading;
  }

  showBoardName(){
    this.hideEditBoardName = true;
    this.showEditBoardName = false;
    this.boardHeadingEdit = this.boardHeading;
  }

  editBoardApiSubmit(){
    this.editBoardNameApi();
  }

  editBoardNameApi(){
    this.showRenameLoader = true;
    this.damService.editBoardName(this.workspaceId, this.boardId, this.boardHeadingEdit).subscribe((data: any) => {
      this.boardHeading = data.title;
      this.showRenameLoader = false;
      this.showEditBoardName = false;
      this.hideEditBoardName = true;
      this.damService.getBoardsList(this.workspaceId).subscribe((data: any) => {
        this.boards = data;
        this.boardname = '';
        this.boardImagesSection = true;
        this.searchImageslistSection = false;
        this.getImagesList(this.boardId);
      });
    },(error) => {
      const errors = error.error || error.statusText;
      Object.keys(errors).map((key) => {
        errors[key].map((message) => {
          this.isShowError = true
          this.boardCreateErrorMessage = message;
          this.showRenameLoader = false;
          // this.alert.error(message);
        })
      })
   });
  }

  editUrlsImageNameApi(urlsId: any){
    this.damService.changeUrlsImageNameApi(this.workspaceId, this.boardId, urlsId, this.imageNameEdit).subscribe((data: any) => {
      this.showUrlsEditImageName = false;
      this.showRenameFormatAdd = false;
      this.currentUrlsIllus.title = data.title;
      this.listFigmaLinks(this.boardId);
    },
    (error: any) => {
      this.showRenameFormatAdd = false;
      if(error.status == 403){
        this.renameErrorMsg = error.error.message;
      } else {
        this.renameErrorMsg = error.error.message;
      }
   });
  }

  onImageLoad(evt) {
        if (evt && evt.target) {
          const width = evt.target.naturalWidth;
          const height = evt.target.naturalHeight;
          const portrait = height > width ? true : false;
        }
      }

  getImageResolution(file){
        var _URL = window.URL || window.webkitURL;
        var img = new Image();
        var objectUrl = _URL.createObjectURL(file);

        img.src = objectUrl;
        img.onload = function (result: any) {
        };
  }

  selectFiles(event, boardHeading: string, boardId: any): void {
    this.progressInfos = [];
    this.replaceAsset = true;

    const files = event.target.files;
    let isValidFormat = true;

    for (let i = 0; i < files.length; i++) {
      const file = files.item(i);
      const fileType = file.type;
      const fileName = file.name;

      if (
        fileType.match('application.*') ||
        fileType.match('pdf.*') ||
        fileType.match('image.*') ||
        fileType.match('video.*') ||
        fileName.endsWith('.pages') ||
        fileName.endsWith('.numbers')
      ) {
        continue;
      } else {
        isValidFormat = false;
        alert('Invalid Format!');
        break;
      }
    }

    if (isValidFormat) {
      this.selectedFiles = files;
      this.uploadFiles(event, boardHeading, boardId);
      // if(this.planName == 'Free') {
      //   if(this.selectedFiles.length > 10) {
      //     this.sendSuccessfulErrorMsg = true;
      //     this.sendSuccessfulErrorMessage = "Maximum 10 images at a time in Free plan."
      //     this.hideSuccesfullFunctionErrorDelete();
      //   } else {
      //     this.uploadFiles(event, boardHeading, boardId);
      //   }
      // } else if(this.planName == 'Plus') {
      //   if(this.selectedFiles.length > 20) {
      //     this.sendSuccessfulErrorMsg = true;
      //     this.sendSuccessfulErrorMessage = "Maximum 10 images at a time in Plus plan."
      //     this.hideSuccesfullFunctionErrorDelete();
      //   } else {
      //     this.uploadFiles(event, boardHeading, boardId);
      //   }
      // } else if(this.planName == 'Professional') {
      //   if(this.selectedFiles.length > 30) {
      //     this.sendSuccessfulErrorMsg = true;
      //     this.sendSuccessfulErrorMessage = "Maximum 30 images at a time in Professional plan."
      //     this.hideSuccesfullFunctionErrorDelete();
      //   } else {
      //     this.uploadFiles(event, boardHeading, boardId);
      //   }
      // } else if(this.planName == 'Enterprise') {
      //   if(this.selectedFiles.length > 40) {
      //     this.sendSuccessfulErrorMsg = true;
      //     this.sendSuccessfulErrorMessage = "Maximum 40 images at a time in Enterprise plan."
      //     this.hideSuccesfullFunctionErrorDelete();
      //   } else {
      //     this.uploadFiles(event, boardHeading, boardId);
      //   }
      // }
    } else {
      this.selectedFiles = undefined;
      event.srcElement.percentage = null;
    }
  }

  uploadFiles(event, boardHeading: string, boardId: any): void {
    this.message = '';
    for (let i = 0; i < this.selectedFiles.length; i++) {
      // this.getImageResolution(this.selectedFiles[i], i, );
      this.upload(i, this.selectedFiles[i], boardHeading, boardId);
    }
  }

  showUploadReplaceDialog() {
    this.uploadVersionStyle = "block";
  }

  closeUploadReplaceDialog() {
    this.uploadVersionStyle = "none";
  }

  getImagesList(boardId: any) {
    this.uploadService.getFiles(this.workspaceId, boardId).subscribe((data: any) => {
      this.fileInfos = data['results'];
      this.totalIllusCount = data['results'].length;
      this.imageExtensionApi();
      this.showTopRightLoader = false;
      this.shimmerSection = false;
    });
  }

  cancelImageSelection(){
    this.count = 0;
    this.imageSelected = false;
    this.downloadDelete = false;
    this.imagesIdList = [];
    this.imagesIds = [];
    this.changeColor = [];
  }

  uploadFilesReplace(event, boardHeading: string, boardId: any): void {
    this.message = '';

    for (let i = 0; i < this.selectedFiles.length; i++) {
      // this.getImageResolution(this.selectedFiles[i], i, );
      this.uploadReplace(i, this.selectedFiles[i], boardHeading, boardId, "true");
    }
  }

  uploadFilesKeep(event, boardHeading: string, boardId: any): void {
    this.message = '';

    for (let i = 0; i < this.selectedFiles.length; i++) {
      // this.getImageResolution(this.selectedFiles[i], i, );
      this.uploadKeepBoth(i, this.selectedFiles[i], boardHeading, boardId, "true");
    }
  }

  upload(idx, file, boardHeading: string, boardId: any): void {
    this.isShowLoadingStatus = true;
    this.progressInfos[idx] = { value: 0, fileName: file.name };
    this.uploadService.upload(file, file.name, boardHeading, boardId, this.workspaceId).subscribe(
      event => {
        if (event.type === HttpEventType.UploadProgress) {
          this.progressInfos[idx].percentage = Math.round(100 * event.loaded / event.total);
          this.progressPecentage = this.progressInfos[idx].percentage;
        } else if (event instanceof HttpResponse) {
          this.uploadService.getFiles(this.workspaceId, boardId).subscribe((data: any) => {
            this.fileInfos = data['results'];
            this.totalIllusCount = data['results'].length;
            this.isShowLoadingStatus = false;
            this.isShowLoadingStatusDone = true;
            this.hideStatusDoneSuccesfullFunction();
            this.imageExtensionApi();
          }
        );
        }
      },
      (error: any) => {
        if(error.status == 400){
          this.isShowLoadingStatusDone = false;
          this.isShowLoadingStatus = false;
          this.uploadedFileName = error.error.title.title;
          this.openUploadOptionsStyleBoard();
        } else if(error.status == 403){
          this.isShowLoadingStatusDone = false;
          this.isShowLoadingStatus = false;
          this.sendSuccessfulErrorMsg = true
          this.sendSuccessfulErrorMessage = error.error.message;
          this.hideSuccesfullFunctionErrorDelete();
        } else {
          this.isShowLoadingStatusDone = false;
          this.isShowLoadingStatus = false;
          this.sendSuccessfulErrorMsg = true
          this.sendSuccessfulErrorMessage = error.error.message;
          this.hideSuccesfullFunctionErrorDelete();
        }
     });
  }

  uploadReplace(idx: any, file: any, boardHeading: string, boardId: any, isReplace: string): void {
      this.progressInfos[idx] = { value: 0, fileName: file.name };
      this.isShowLoadingStatus = true;
      this.uploadService.uploadWithResolutionReplace(file, file.name, boardHeading, boardId, this.workspaceId, isReplace).subscribe(
        event => {
          this.closeUploadOptionsStyleBoard();
          if (event.type === HttpEventType.UploadProgress) {
            this.progressInfos[idx].percentage = Math.round(100 * event.loaded / event.total);
            this.progressPecentage = this.progressInfos[idx].percentage;
          } else if (event instanceof HttpResponse) {
            this.uploadService.getFiles(this.workspaceId, boardId).subscribe((data: any) => {
              this.fileInfos = data['results'];
              this.totalIllusCount = data['results'].length;
              this.isShowLoadingStatus = false;
              this.isShowLoadingStatusDone = true;
              this.hideStatusDoneSuccesfullFunction();
              this.imageExtensionApi();
            }
          );
          }
        },
          (error) => {
            const errors = error.error || error.statusText;
            Object.keys(errors).map((key) => {
              errors[key].map((message) => {
                this.isShowLoadingStatusDone = false;
                this.uploadedFileName = ""
                this.isShowLoadingStatus = false;
                this.openUploadOptionsStyleBoard();
              })
            })
         }
       );
      }

      uploadKeepBoth(idx: any, file: any, boardHeading: string, boardId: any, isKeep: string): void {
        this.progressInfos[idx] = { value: 0, fileName: file.name };
        this.isShowLoadingStatus = true;
        this.uploadService.uploadWithResolutionKeepBothNew(file, file.name, boardHeading, boardId, this.workspaceId, isKeep).subscribe(
          event => {
            if (event.type === HttpEventType.UploadProgress) {
              this.progressInfos[idx].percentage = Math.round(100 * event.loaded / event.total);
              this.closeUploadOptionsStyleBoard();
            } else if (event instanceof HttpResponse) {
              // this.fileInfos = this.uploadService.getFiles(boardId);
              this.uploadService.getFiles(this.workspaceId, boardId).subscribe((data: any) => {
                this.fileInfos = data['results'];
                this.totalIllusCount = data['results'].length;
                this.isShowLoadingStatus = false;
                this.isShowLoadingStatusDone = true;
                this.hideStatusDoneSuccesfullFunction();
                this.closeUploadOptionsStyleBoard();
                this.imageExtensionApi();
              }
            );
            }
          },
            (error) => {
              const errors = error.error || error.statusText;
              Object.keys(errors).map((key) => {
                errors[key].map((message) => {
                  this.isShowLoadingStatus = false;
                  this.isShowLoadingStatusDone = false;
                  this.uploadedFileName = ""
                  this.openUploadOptionsStyleBoard();
                })
              })
           }
         );
        }

    downloadImage(currentImageId: any, titleImage: string, boardId: any): void {
      this.damService.downloadImages(this.workspaceId, boardId, currentImageId).subscribe((data: any) => {
        saveAs(data, titleImage)
      },
        (error: any) => {
          if (error.status == 403) {
            // this.openLimitModal(this.limitModal);
          }
          else {
            // this.alert.alert("Alert", "Limit reached! Please login to download")
          }
        }
      );
    }

    getImage(currentImage: any, format: any) {
      this.imageDownloadShowFormat = format;
      if (format == 'PNG') {
        this.imageDownloadFormat = 'png';
      } else if (format == 'JPEG') {
        this.imageDownloadFormat = 'jpeg';
      } else if (format == 'TIFF') {
        this.imageDownloadFormat = 'tiff';
      } else if (format == 'WEBP') {
        this.imageDownloadFormat = 'webp';
      } else if (format == 'SVG') {
        this.imageDownloadFormat = 'svg';
      } else if (format == 'GIF') {
        this.imageDownloadFormat = 'GIF';
      } else if (format == 'AI') {
        this.imageDownloadFormat = 'ai';
      } else if (format == 'BMP') {
        this.imageDownloadFormat = 'bmp';
      }
    }

    downloadFormatImage(currentImageId: any, titleImage: string, boardId: any): void {
      this.showDownloadLoader = true;
      this.damService.downloadFormatImages(this.workspaceId, boardId, currentImageId, this.imageDownloadFormat).subscribe((data: any) => {
        let stringToSplit = titleImage;
        let imageName = stringToSplit.split(".");
        saveAs(data, imageName[0])
        this.showDownloadLoader = false;
        this.showDownloadDialog = false;
      },
        (error: any) => {
          this.showDownloadLoader = false;
          if (error.status == 403) {
            // this.openLimitModal(this.limitModal);
          }
          else {
            // this.alert.alert("Alert", "Limit reached! Please login to download")
          }
        }
      );
    }

  selectFilter(e, searchTxt: string){
    if(e.target.checked){
      this.filterImages(this.boardId, searchTxt);
    }else{
      this.filterRemoveImages(this.boardId, searchTxt);
    }
  }

  formatList = [];

  filterImages(boardId: any, searchText: string){
    this.formatList.push(searchText);
    this.damService.filterImage(this.workspaceId, boardId, this.formatList).subscribe((data: any) => {
      this.fileInfos = data['results'];
      this.totalIllusCount = data['results'].length;
    });
  }

  filterRemoveImages(boardId: any, searchText: string){
    this.formatList.forEach((element,index)=>{
      if(element==searchText) delete this.formatList[index];
    });
    if(this.formatList.length == 0){
      this.formatList = [];
      this.damService.filterImage(this.workspaceId, boardId, this.formatList).subscribe((data: any) => {
        this.fileInfos = data['results'];
        this.totalIllusCount = data['results'].length;
      });
    }else{
      this.damService.filterImage(this.workspaceId, boardId, this.formatList).subscribe((data: any) => {
        this.fileInfos = data['results'];
        this.totalIllusCount = data['results'].length;
      });
    }
  }

  clearFilter(){
    this.checkboxes.forEach((element) => {
      element.nativeElement.checked = false;
    });
    this.formatList = [];
    this.damService.filterImage(this.workspaceId, this.boardId, this.formatList).subscribe((data: any) => {
      this.fileInfos = data['results'];
      this.totalIllusCount = data['results'].length;
    });
  }

  addFavouriteImage(imageId: any, imageNameTitle: any, boardId: any, fromComingSection: any){
    this.closeImageEditField();
    this.showRenameFormatAdd = false;
    this.showTopRightLoader = true;
    this.damService.addFavouriteImages(this.workspaceId, imageId).subscribe((data: any) => {
      if(fromComingSection == 'nested') {
        this.showtableViewData = false;
        this.showNestedViewData = true;
        this.isTableSelected = false;
        this.isNestedSelected = true;
        this.boardImagesSection = true;
        this.searchImageslistSection = false;
        this.showTopRightLoader = false;
        this.getImagesList(boardId);
        this.getFavImagesList();
      } else if(fromComingSection == 'table') {
        this.showtableViewData = true;
        this.showNestedViewData = false;
        this.isTableSelected = true;
        this.isNestedSelected = false;
        this.boardImagesSection = true;
        this.searchImageslistSection = false;
        this.showTopRightLoader = false;
        this.getImagesList(boardId);
        this.getFavImagesList();
      } else if(fromComingSection == 'dialog') {
        this.uploadService.getFiles(this.workspaceId, boardId).subscribe((data: any) => {
          this.fileInfos = data['results'];
          this.boardImagesSection = true;
          this.searchImageslistSection = false;
          this.showTopRightLoader = false;
          for(var i = 0 ; i < this.fileInfos.length ; i++) {
            this.currentIllus = this.fileInfos[this.currentIllusPosition];
          }
          this.showTopRightLoader = false;
          this.getFavImagesList();
        });
      }
    });
  }

  addSearchFavouriteImage(imageId: any, imageNameTitle: any, fromPos: any){
    this.showTopRightLoader = true;
    this.damService.addFavouriteImages(this.workspaceId, imageId).subscribe((data: any) => {
      if(fromPos == true) {
        this.damService.searchImagesArray(this.workspaceId, this.searchTerms).subscribe((data: any) => {
          this.searchText = "";
          this.imagesList = data.image;
          this.searchData = '' + this.searchTextSet;
          this.boardImagesSection = false;
          this.searchImageslistSection = true;
          this.showTopRightLoader = false;
          for(var i = 0 ; i < this.imagesList.length ; i++) {
            this.currentIllus = this.imagesList[this.currentSearchIllusPosition];
          }
        });
      } else {
        this.showTopRightLoader = false;
        this.searchArrayImages(this.searchText, this.searchTerms);
      }
    });
  }

  removeFavouriteImage(imageId: any, title: string){
    this.damService.removeFavouriteImages(this.workspaceId, imageId, title).subscribe((data: any) => {

    });
  }

  ownerListApi(){
    this.damService.getOwnerList(this.workspaceId).subscribe((data: any) => {
      this.ownerEmail = data.email;
      this.planName = data.plan_title;
      this.ownerName = data.first_name + " " + data.last_name;
      this.totalSpaceAllowed = data.allowed_dam_space_kb/1000000;
      this.consumedSpaceAllowed = data.current_dam_space/1000;
      this.totalSpaceAllowedProgress = data.allowed_dam_space_kb/1000;
      this.planId = data.plan_id;
      this.workspaceCountAllowed = data.allowed_workspace;
      this.totalWorkspaceCreated = data.total_workspace_created;
    });
    // this.listFigmaLinks(this.boardId);
  }

  showUpgradePlans(){
    window.scrollTo(0, 0);
    if (this.currentUser) {
      this.googleAnalyticsService.event('upgrade_plan_boards_screen_click', 'upgrade_plan', this.currentUser.firstName +" "+this.currentUser.lastName);
      localStorage.setItem('workspaceDetails', JSON.stringify({ workspaceId: this.workspaceId,
        workspaceName: this.workspaceName, userRole: this.userRole }));
      this.router.navigate(['/dam/subscription']);
    }
  }

  boardlistClick(boardName: string, boardId: any){
    this.boardId = boardId;
    this.searchTerms = [];
    this.isShowLoadingStatus = false;
    this.moveBoardId = boardId;
    this.count = 0;
    this.checkboxes.forEach((element) => {
      element.nativeElement.checked = false;
    });
    localStorage.setItem('boardDetails', JSON.stringify({ boardId: boardId, boardTitle: boardName}));
    this.router.navigate(['/dam/'+boardName]);
    this.downloadDelete = false;
    this.imagesIdList = [];
    this.imagesIds = [];
    this.changeColor = [];
    this.imageSelected = false;
    var details = JSON.parse(localStorage.getItem('boardDetails'));
    this.boardHeading = boardName;
    this.boardname = boardName;
    this.titleService.setTitle(boardName + "| Board | Crafttor");
    this.currentBoard = this.boardId;
    this.searchText = '';
    this.boardSearchKeyword = '';
    this.searchImageslistSection = false;
    this.boardImagesSection = true;
    this.getImagesList(boardId);
  }

  imageExtensionApi(){
    this.damService.imagesExtension(this.workspaceId, this.boardId).subscribe((data: any) => {
      this.imagesExtension = data['image_formats'];
    });
  }

  // onSubmit() {
  //   if(this.searchText != '') {
  //     this.searchImages(this.searchText);
  //   }
  // }

  onSearchBoards() {
    this.searchBoards(this.boardSearchKeyword);
  }

  searchBoards(searchText: string = ""){
    this.downloadDelete = false;
    this.changeColor = [];
    this.imageSelected = false;
    this.damService.searchBoards(this.workspaceId, searchText).subscribe((data: any) => {
      this.searchedBoards = data;
      this.showSearchBoardOlderList = false;
      this.showSearchBoardList = true;
      this.boardSearchKeyword = '';
    },(error) => {
      this.closeMoveImagesStyleBoard();
      const errors = error.error || error.statusText;
      Object.keys(errors).map((key) => {
        errors[key].map((message) => {
          this.boardSearchKeyword = '';
          this.showSearchBoardOlderList = true;
          this.showSearchBoardList = false;
          this.sendSuccessfulErrorMsg = true
          this.sendSuccessfulErrorMessage = message;
          this.hideSuccesfullFunctionErrorDelete();
        })
      })
    });
  }

  searchImages(searchText: string = ""){
    this.downloadDelete = false;
    this.imagesIdList = [];
    this.imagesIds = [];
    this.changeColor = [];
    this.imageSelected = false;
    this.searchTextSet = searchText;
    this.damService.searchImages(this.workspaceId, searchText).subscribe((data: any) => {
      this.imagesList = data.image;
      this.searchData = this.searchText;
      this.boardImagesSection = false;
      this.searchImageslistSection = true;
    });
  }

  openDeleteBoardShare(boardId: any, boardName: string) {
    this.deleteBoardId = boardId;
    this.deleteBoardName = boardName;
    this.deleteBoardStyle = "block";
  }

  closeDeleteBoardShare() {
   this.deleteBoardStyle = "none";
  }

  openVerifyBoard(boardId: any, boardName: string){
    this.verifyBoardStyle = "block";
  }

  closeVerifyBoard() {
   this.verifyBoardStyle = "none";
  }

  openMoveImagesStyleBoard(imageId: any, moveFromScreen: any, pos: any, boardId: any){
    this.showTopRightLoader = true;
    this.moveFromBoardId = boardId;
    this.moveFromSearch = moveFromScreen;
    this.imagesIds.push(imageId);
    this.currentSearchIllusPosition = pos;
    this.damService.getMoveBoardsList(this.workspaceId, boardId).subscribe((data: any) => {
      this.showTopRightLoader = false;
      this.moveBoards = data;
    },
      (error: any) => {
        if (error.status == 403) {
          this.showTopRightLoader = false;
          this.sendSuccessfulErrorMsg = true
          this.sendSuccessfulErrorMessage = error.error.message;
          this.hideSuccesfullFunctionErrorDelete();
        }
        else {
          this.showTopRightLoader = false;
          this.sendSuccessfulErrorMsg = true
          this.sendSuccessfulErrorMessage = error.error.message;
          this.hideSuccesfullFunctionErrorDelete();
        }
      }
    );
    this.moveImagesStyle = "block";
  }

  openMultipleMoveImagesStyleBoard(moveFromScreen: any){
    this.showTopRightLoader = true;
    this.moveFromSearch = moveFromScreen;
    console.log("get image data : "+this.moveFromSearch);
    this.damService.getMoveBoardsList(this.workspaceId, this.moveBoardId).subscribe((data: any) => {
      this.moveBoards = data;
      this.showTopRightLoader = false;
    },
      (error: any) => {
        if (error.status == 403) {
          this.showTopRightLoader = false;
          this.sendSuccessfulErrorMsg = true
          this.sendSuccessfulErrorMessage = error.error.message;
          this.hideSuccesfullFunctionErrorDelete();
        }
        else {
          this.showTopRightLoader = false;
          this.sendSuccessfulErrorMsg = true
          this.sendSuccessfulErrorMessage = error.error.message;
          this.hideSuccesfullFunctionErrorDelete();
        }
      }
    );
    this.moveImagesStyle = "block";
  }

  closeMoveImagesStyleBoard() {
   this.moveImagesStyle = "none";
   this.boardSearchKeyword = '';
   this.showSearchBoardOlderList = true;
   this.showSearchBoardList = false;
  }

  openDownloadImagesStyleBoard(downloadBoardName: string, downloadBoardId: any){
    this.downloadBoardName = downloadBoardName;
    this.downloadImagesStyle = "block";
  }

  closeDownloadImagesStyleBoard() {
   this.downloadImagesStyle = "none";
  }

  openDeleteStyleBoard(){
    this.deleteProcessStyle = "block";
  }

  closeDeleteStyleBoard() {
   this.showLeaveLoader = false;
   this.deleteProcessStyle = "none";
  }

  uploadImageCondition() {
    if (this.keepBoth == true) {
      this.uploadFilesKeep(event, this.boardHeading, this.boardId)
    } else if (this.replaceAsset == true) {
      // this.showUploadReplaceDialog();
      this.uploadFilesReplace(event, this.boardHeading, this.boardId)
    }
  }

downloadAllImages (fileData: any) {
    for(let imges of fileData) {
      this.imagesIds.push(imges.id)
    }
    this.showZipDownloadLoader = true;
    this.damService.downloadZipFile(this.workspaceId, this.boardId, this.imagesIds).subscribe((data: any) => {
        saveAs(data)
        this.showZipDownloadLoader = false;
        this.imagesIdList = [];
        this.imagesIds = [];
        this.changeColor = [];
        this.imageSelected = false;
        this.downloadDelete = false;
        this.count = 0;
        this.closeDownloadImagesStyleBoard();
     },
      (error: any) => {
         if (error.status == 403) {
           this.showZipDownloadLoader = false;
           this.sendSuccessfulErrorMsg = true
           this.sendSuccessfulErrorMessage = error.error.message;
           this.hideSuccesfullFunctionErrorDelete();
         } else {
           this.showZipDownloadLoader = false;
           this.sendSuccessfulErrorMsg = true
           this.sendSuccessfulErrorMessage = error.error.message;
           this.hideSuccesfullFunctionErrorDelete();
         }
       }
     );
  }

  openBoardListPopUp (imgId: any) {
    this.imagesIds.push(imgId)
    this.openBoardList = true;
  }

  hideMoveToDropdown () {
    this.openBoardList = false;
  }

  deleteBoard(){
    this.showDeleteLeaveLoader = true;
    this.selectedIndex = -1;
    // this.damService.deleteBoard
    this.damService.archiveBoards(this.workspaceId, this.deleteBoardId).subscribe((data: any) => {
      this.sendSuccessful = true;
      this.successfullMessage = this.deleteBoardName + " moved to trash";
      this.hideSuccesfullFunction();
      this.showDeleteLeaveLoader = false;
      this.closeDeleteBoardShare();
      this.getBoardDataAfterDelete();
    },
    (error) => {
      this.closeDeleteBoardShare();
      if(error.status == 403){
        this.showDeleteLeaveLoader = false;
        this.sendSuccessfulErrorMsg = true
        this.sendSuccessfulErrorMessage = error.error.Message;
        this.hideSuccesfullFunctionErrorDelete();
      } else if(error.status == 401){
        this.showDeleteLeaveLoader = false;
        this.sendSuccessfulErrorMsg = true
        this.sendSuccessfulErrorMessage = error.error.Message;
        this.hideSuccesfullFunctionErrorDelete();
      } else {
        this.showDeleteLeaveLoader = false;
        this.sendSuccessfulErrorMsg = true
        this.sendSuccessfulErrorMessage = error.error.Message;
        this.hideSuccesfullFunctionErrorDelete();
      }
   });
  }

  deleteBoards(id: any, title: string){
    this.selectedIndex = -1;
    // this.damService.deleteBoard
    this.damService.archiveBoards(this.workspaceId, id).subscribe((data: any) => {
      this.boardImagesSection = true;
      this.searchImageslistSection = false;
      this.reStartListing();
    },
    (error) => {
      this.boardImagesSection = true;
      this.searchImageslistSection = false;
      if(error.status == 403){
        this.sendSuccessfulErrorMsg = true
        this.sendSuccessfulErrorMessage = error.error.Message;
        this.hideSuccesfullFunctionErrorDelete();
      } else if(error.status == 401){
        this.sendSuccessfulErrorMsg = true
        this.sendSuccessfulErrorMessage = error.error.Message;
        this.hideSuccesfullFunctionErrorDelete();
      } else {
        this.sendSuccessfulErrorMsg = true
        this.sendSuccessfulErrorMessage = error.error.Message;
        this.hideSuccesfullFunctionErrorDelete();
      }
   });
  }

  deleteFullBoards(title: string){
    this.selectedIndex = -1;
    this.damService.archiveBoards(this.workspaceId, this.boardId).subscribe((data: any) => {
      this.searchImageslistSection = false;
      this.boardImagesSection = true;
      this.getBoardDataAfterDelete();
    });
  }

  getBoardsList() {
    // this.showLoaderBoardsList = true;
    this.damService.getBoardsList(this.workspaceId).subscribe((data: any) => {
      this.boards = data;
      this.showLoaderBoardsList = false;
    });
  }

  getBoardDataAfterDelete() {
    this.damService.getBoardsList(this.workspaceId).subscribe((data: any) => {
      if (data.length == 0) {
        this.mainClick();
      } else {
        this.boards = data;
        this.newBoardIdAfterDelete = data[0].id;
        this.newBoardNameAfterDelete = data[0].title;
        this.boardlistClick(data[0].title, data[0].id);
      }
    });
  }

  moveImagesToOtherBoard(newBoardId: any, boardTitle: string) {
    this.sendSuccessful = false;
    this.downloadDelete = false;
    this.closeMoveImagesStyleBoard();
    this.showTopRightLoader = true;
    this.damService.moveImagesToOtherBoard(this.workspaceId, this.boardId,
      this.imagesIds, newBoardId).subscribe((data: any) => {
        this.showTopRightLoader = false;
        this.sendSuccessful = true;
        this.successfullMessage = data.message;
        this.hideSuccesfullFunction();
        if(this.moveFromSearch == 'search') {
          this.damService.searchImagesArray(this.workspaceId, this.searchTerms).subscribe((data: any) => {
            this.imagesList = data.image;
            this.searchData = this.searchText;
            this.boardImagesSection = false;
            this.searchImageslistSection = true;
            for(var i = 0 ; i < this.imagesList.length ; i++) {
              this.currentIllus = this.imagesList[this.currentSearchIllusPosition];
            }
          });
        } else if(this.moveFromSearch == 'nested') {
            this.boardImagesSection = true;
            this.showNestedViewData = true;
            this.showtableViewData = false;
            this.searchImageslistSection = false;
            this.getImagesList(this.moveFromBoardId);
        } else if(this.moveFromSearch == 'table') {
            this.boardImagesSection = true;
            this.showNestedViewData = false;
            this.showtableViewData = true;
            this.searchImageslistSection = false;
            this.getImagesList(this.moveFromBoardId);
        } else if(this.moveFromSearch == 'movemultiple') {
            this.boardImagesSection = true;
            this.showNestedViewData = true;
            this.showtableViewData = false;
            this.searchImageslistSection = false;
            this.imagesIdList = [];
            this.imagesIds = [];
            this.changeColor = [];
            this.imageSelected = false;
            this.downloadDelete = false;
            this.openBoardList = false;
            this.count = 0;
            this.getImagesList(this.boardId);
          }
      },(error) => {
        this.closeMoveImagesStyleBoard();
        this.showTopRightLoader = false;
        const errors = error.error || error.statusText;
        Object.keys(errors).map((key) => {
          errors[key].map((message) => {
            this.imagesIdList = [];
            this.imagesIds = [];
            this.changeColor = [];
            this.imageSelected = false;
            this.downloadDelete = false;
            this.openBoardList = false;
            this.showSearchBoardOlderList = true;
            this.showSearchBoardList = false;
            this.boardSearchKeyword = '';
            this.count = 0;
            this.sendSuccessfulErrorMsg = true
            this.sendSuccessfulErrorMessage = message;
            this.hideSuccesfullFunctionErrorDelete();
          })
        })
      }
    );
  }

  downloadSingleImage(imgId: any, imgTitle: string, boardId: any){
    this.damService.downloadImages(this.workspaceId, boardId, imgId).subscribe((data: any) => {
        saveAs(data, imgTitle)
        this.imagesIdList = [];
        this.imagesIds = [];
        this.changeColor = [];
        this.imageSelected = false;
        this.downloadDelete = false;
        this.count = 0;
     },(error) => {
       const errors = error.error || error.statusText;
       Object.keys(errors).map((key) => {
         errors[key].map((message) => {
           this.sendSuccessfulErrorMsg = true
           this.sendSuccessfulErrorMessage = message;
           this.hideSuccesfullFunctionErrorDelete();
           this.imagesIdList = [];
           this.imagesIds = [];
           this.changeColor = [];
           this.imageSelected = false;
           this.downloadDelete = false;
           this.count = 0;
         })
       })
     });
  }

  downloadMultipleImage(){
    if(this.count <= 1){
      for(let ids of this.imagesIdList){
         this.damService.downloadImages(this.workspaceId, this.boardId, ids.id).subscribe((data: any) => {
             saveAs(data, ids.title)
             this.hideContent();
             this.imagesIdList = [];
             this.imagesIds = [];
             this.changeColor = [];
             this.imageSelected = false;
             this.downloadDelete = false;
             this.count = 0;
          });
      }
    }else{
      this.downloadZipFile();
    }
  }

  downloadZipFile(){
    for(let ids of this.imagesIdList){
      this.imagesIds.push(ids.id)
    }
    this.damService.downloadZipFile(this.workspaceId, this.boardId, this.imagesIds).subscribe((data: any) => {
        saveAs(data)
        this.imagesIdList = [];
        this.imagesIds = [];
        this.changeColor = [];
        this.imageSelected = false;
        this.downloadDelete = false;
        this.count = 0;
     },(error) => {
       const errors = error.error || error.statusText;
       Object.keys(errors).map((key) => {
         errors[key].map((message) => {
           this.sendSuccessfulErrorMsg = true
           this.sendSuccessfulErrorMessage = message;
           this.hideSuccesfullFunctionErrorDelete();
           this.imagesIdList = [];
           this.imagesIds = [];
           this.changeColor = [];
           this.imageSelected = false;
           this.downloadDelete = false;
           this.count = 0;
         })
       })
     });
  }

  archiveSingleImage(imgId: any, boardId: any, imgTitle: any) {
    this.showTopRightLoader = true;
    this.damService.archiveSingleImages(this.workspaceId, boardId, imgId).subscribe((data: any) => {
      this.uploadService.getFiles(this.workspaceId, this.boardId).subscribe((data: any) => {
        this.sendSuccessful = true;
        this.successfullMessage = imgTitle + " moved to trash";
        this.hideSuccesfullFunction();
        this.fileInfos = data['results'];
        this.totalIllusCount = data['results'].length;
        this.showTopRightLoader = false;
        this.imagesIdList = [];
        this.imagesIds = [];
        this.changeColor = [];
        this.imageSelected = false;
        this.downloadDelete = false;
        this.count = 0;
        this.imageExtensionApi();
      });
    });
  }

  deleteSingleImage(imgId: any){
    // this.imageDeleteProcessStyle = "block";
    this.showTopRightLoader = true;
    this.damService.archiveSingleImages(this.workspaceId, this.boardId, imgId).subscribe((data: any) => {
      this.uploadService.getFiles(this.workspaceId, this.boardId).subscribe((data: any) => {
        this.fileInfos = data['results'];
        this.totalIllusCount = data['results'].length;
        // this.imageDeleteProcessStyle = "none";
        this.showTopRightLoader = false;
        this.imagesIdList = [];
        this.imagesIds = [];
        this.changeColor = [];
        this.imageSelected = false;
        this.downloadDelete = false;
        this.count = 0;
        this.imageExtensionApi();
      });
    },(error) => {
      this.imageDeleteProcessStyle = "none";
      if(error.status == 403){
        this.sendSuccessfulErrorMsg = true
        this.sendSuccessfulErrorMessage = "You are not allowed to delete this asset.";
        this.hideSuccesfullFunctionErrorDelete();
      } else {
        this.sendSuccessfulErrorMsg = true
        this.sendSuccessfulErrorMessage = "Something went wrong.";
        this.hideSuccesfullFunctionErrorDelete();
      }
   });
  }

  deleteSingleDialogImage(imgId: any){
    // this.damService.deleteImages
    this.damService.archiveSingleImages(this.workspaceId, this.boardId, imgId).subscribe((data: any) => {
      this.uploadService.getFiles(this.workspaceId, this.boardId).subscribe((data: any) => {
        this.fileInfos = data['results'];
        this.totalIllusCount = data['results'].length;
        this.imageDeleteProcessStyle = "none";
        this.imagesIdList = [];
        this.imagesIds = [];
        this.changeColor = [];
        this.imageSelected = false;
        this.downloadDelete = false;
        this.count = 0;
        this.imageExtensionApi();
      });
    },(error) => {
      if(error.status == 403){
        this.sendSuccessfulErrorMsg = true
        this.sendSuccessfulErrorMessage = "You are not allowed to delete this asset.";
        this.hideSuccesfullFunctionErrorDelete();
      } else {
        this.sendSuccessfulErrorMsg = true
        this.sendSuccessfulErrorMessage = "Something went wrong.";
        this.hideSuccesfullFunctionErrorDelete();
      }
   });
  }

  deleteSingleSearchDialogImage(imgId: any){
    // this.damService.deleteImages
    this.damService.archiveSingleImages(this.workspaceId, this.boardId, imgId).subscribe((data: any) => {
      this.searchArrayImages(this.searchText, this.searchTerms);
    },(error) => {
      if(error.status == 403){
        this.sendSuccessfulErrorMsg = true
        this.sendSuccessfulErrorMessage = "You are not allowed to delete this asset.";
        this.hideSuccesfullFunctionErrorDelete();
      } else {
        this.sendSuccessfulErrorMsg = true
        this.sendSuccessfulErrorMessage = "Something went wrong.";
        this.hideSuccesfullFunctionErrorDelete();
      }
   });
  }

  archiveSingleSearchDialogImage(imgId: any){
    this.damService.archiveSingleImages(this.workspaceId, this.boardId, imgId).subscribe((data: any) => {
      this.searchArrayImages(this.searchText, this.searchTerms);
    },(error) => {
      if(error.status == 403){
        this.sendSuccessfulErrorMsg = true
        this.sendSuccessfulErrorMessage = "You are not allowed to delete this asset.";
        this.hideSuccesfullFunctionErrorDelete();
      } else {
        this.sendSuccessfulErrorMsg = true
        this.sendSuccessfulErrorMessage = "Something went wrong.";
        this.hideSuccesfullFunctionErrorDelete();
      }
   });
  }

  deleteMultipleImage(){
    this.showTopRightLoader = true;
    for(let ids of this.imagesIdList){
      this.damService.archiveSingleImages(this.workspaceId, this.boardId, ids.id).subscribe((data: any) => {
        this.uploadService.getFiles(this.workspaceId, this.boardId).subscribe((data: any) => {
          this.fileInfos = data['results'];
          this.totalIllusCount = data['results'].length;
          // this.imageDeleteProcessStyle = "none";
          this.showTopRightLoader = false;
          this.imagesIdList = [];
          this.imagesIds = [];
          this.changeColor = [];
          this.imageSelected = false;
          this.downloadDelete = false;
          this.count = 0;
          this.imageExtensionApi();
        });
        this.sendSuccessful = true;
        this.successfullMessage = "Assets moved to trash";
        this.hideSuccesfullFunction();
      },(error) => {
        this.imageDeleteProcessStyle = "none";
        if(error.status == 403){
          this.sendSuccessfulErrorMsg = true
          this.sendSuccessfulErrorMessage = "You are not allowed to delete this asset.";
          this.imageDeleteProcessStyle = "none";
          this.imagesIdList = [];
          this.imagesIds = [];
          this.changeColor = [];
          this.imageSelected = false;
          this.downloadDelete = false;
          this.count = 0;
          this.hideSuccesfullFunctionErrorDelete();
        } else {
          this.sendSuccessfulErrorMsg = true
          this.sendSuccessfulErrorMessage = "Something went wrong.";
          this.imageDeleteProcessStyle = "none";
          this.imagesIdList = [];
          this.imagesIds = [];
          this.changeColor = [];
          this.imageSelected = false;
          this.downloadDelete = false;
          this.count = 0;
          this.hideSuccesfullFunctionErrorDelete();
        }
     });
    }
  }

  showDownloadDeleteButtons(ivalue: any, i: any, imageId: any, titles: string){
    this.shareImageLink = "";
    this.downloadDelete = true;
    this.imageSelected = true;
    this.sendSuccessful = false;
    if(ivalue == false){
      this.count--;
      if(this.count < 1){
        this.count = 0;
        this.imageSelected = false;
        this.downloadDelete = false;
        this.imagesIdList = [];
        this.imagesIds = [];
        this.changeColor = [];
      }
      if(this.count <= 1){
        this.fileText = 'file';
      }else{
        this.fileText = 'files';
      }
      let index = this.imagesIds.indexOf(imageId);
      if (index !== -1) {
        this.imagesIds.splice(index, 1);
        this.imagesIdList.splice(index, 1);
      }
    }else{
      this.count++;
      if(this.count <= 1){
        this.fileText = 'file';
      }else{
        this.fileText = 'files';
      }
      this.imagesIds.push(imageId);
      this.imagesIdList.push({id: imageId, title: titles});
    }
  }

  reStartListing(){
    this.getBoardsList();
  }

  allMediaRedirect(){
    this.router.navigate(['/dam']);
  }

  newCrafttor(): void {
    this.openNewWorkspaceDialog();
  }

  openUploadOptionsStyleBoard() {
    this.uploadOptionsStyle = "block";
  }

  closeUploadOptionsStyleBoard() {
    this.uploadOptionsStyle = "none";
  }

  openPopupShare(imgId: any) {
    this.fromAssets = true;
    this.shareStyle = "block";
    this.hitSharePopUpApi(imgId);
  }

  closePopupShare() {
    this.fromAssets = false;
    this.shareStyle = "none";
    this.imagesIds = [];
  }

  showTagFieldData(){
    this.plusButton = false;
    this.tagFieldArea = true;
  }

  onSubmitTag(boardId: any){
    this.addTagsData(this.addTagText, this.currentIllusPosition, boardId);
  }

  onSubmitSearchTag(boardId: any){
    this.addSearchTagsData(this.addTagText, this.currentIllusPosition, boardId);
  }

  onUrlsSubmitTag(boardId: any){
    this.addUrlsTagsData(this.addUrlsTagText, this.currentUrlsIllusPosition, boardId);
  }

  onSubmitSuggestedTag(tag: any, boardId: any){
   this.addSuggestedTagsData(tag, boardId);
  }

  onSubmitSuggestedSearchTag(tag: any, boardId: any){
   this.addSuggestedSearchTagsData(tag, boardId);
  }

  onSubmitUrlsSuggestedTag(tag: any, boardId: any){
   this.addUrlsSuggestedTagsData(tag, boardId);
  }

  addTagsData(addTagText: string, position: any, boardId: any){
    this.addTagText = '';
    this.plusButton = false;
    this.tagFieldArea = true;
    this.damService.addImageTags(this.workspaceId, boardId, this.currentIllus.id,
      addTagText).subscribe((data: any) => {
        this.addedTag = data.tag;
        this.addedTagList.push({tags: this.addedTag});
        this.getImagesList(this.boardId);
    });
  }

  addSearchTagsData(addTagText: string, position: any, boardId: any){
    this.addTagText = '';
    this.plusButton = false;
    this.tagFieldArea = true;
    this.damService.addImageTags(this.workspaceId, boardId, this.currentIllus.id,
      addTagText).subscribe((data: any) => {
        this.addedTag = data.tag;
        this.addedTagList.push({tags: this.addedTag});
        this.searchArrayImages(this.searchText, this.searchTerms);
    });
  }

  addUrlsTagsData(addTagText: string, position: any, boardId: any){
    this.addTagText = '';
    this.plusButton = false;
    this.tagFieldArea = true;
    this.damService.addUrlsImageTags(this.workspaceId, boardId, this.currentUrlsIllus.id,
      addTagText).subscribe((data: any) => {
        this.addedUrlsTag = data.tag;
        this.addedUrlsTagList.push({tags: this.addedUrlsTag});
        this.listFigmaLinks(this.boardId);
    });
  }

  addSuggestedTagsData(addTagText: string, boardId: any){
    this.addTagText = '';
    this.plusButton = true;
    this.tagFieldArea = false;
    this.damService.addImageTags(this.workspaceId, boardId, this.currentIllus.id,
      addTagText).subscribe((data: any) => {
        this.addedTag = data.tag;
        this.addedTagList.push({tags: this.addedTag});
        this.getImagesList(this.boardId);
    });
  }

  addSuggestedSearchTagsData(addTagText: string, boardId: any){
    this.addTagText = '';
    this.plusButton = true;
    this.tagFieldArea = false;
    this.damService.addImageTags(this.workspaceId, boardId, this.currentIllus.id,
      addTagText).subscribe((data: any) => {
        this.addedTag = data.tag;
        this.addedTagList.push({tags: this.addedTag});
        this.searchArrayImages(this.searchText, this.searchTerms);
    });
  }

  addUrlsSuggestedTagsData(addTagText: string, boardId: any){
    this.addTagText = '';
    this.plusButton = true;
    this.tagFieldArea = false;
    this.damService.addUrlsImageTags(this.workspaceId, boardId, this.currentUrlsIllus.id,
      addTagText).subscribe((data: any) => {
        this.addedUrlsTag = data.tag;
        this.addedUrlsTagList.push({tags: this.addedUrlsTag});
        this.listFigmaLinks(this.boardId);
    });
  }

  deleteImageTags(title: string, i: any){
    this.damService.deleteImageTags(this.workspaceId, this.boardId, this.currentIllus.id, title).subscribe((data: any) => {
      this.currentIllus.tags.splice(i, 1);
      this.getImagesList(this.boardId);
    });
  }

  deleteImageTagsList(title: string, i: any){
    this.damService.deleteImageTags(this.workspaceId, this.boardId, this.currentIllus.id, title).subscribe((data: any) => {
      this.addedTagList.splice(i, 1);
      this.getImagesList(this.boardId);
    });
  }

  deleteSearchImageTags(title: string, i: any){
    this.damService.deleteImageTags(this.workspaceId, this.boardId, this.currentIllus.id, title).subscribe((data: any) => {
      this.currentIllus.tags.splice(i, 1);
      this.searchArrayImages(this.searchText, this.searchTerms);
    });
  }

  deleteSearchImageTagsList(title: string, i: any){
    this.damService.deleteImageTags(this.workspaceId, this.boardId, this.currentIllus.id, title).subscribe((data: any) => {
      this.addedTagList.splice(i, 1);
      this.searchArrayImages(this.searchText, this.searchTerms);
    });
  }

  deleteUrlsImageTags(title: string, i: any){
    this.damService.deleteUrlsImageTags(this.workspaceId, this.boardId, this.currentUrlsIllus.id, title).subscribe((data: any) => {
      this.currentUrlsIllus.tags.splice(i, 1);
      this.listFigmaLinks(this.boardId);
    });
  }

  deleteUrlsImageTagsList(title: string, i: any){
    this.damService.deleteUrlsImageTags(this.workspaceId, this.boardId, this.currentUrlsIllus.id, title).subscribe((data: any) => {
      this.addedUrlsTagList.splice(i, 1);
      this.listFigmaLinks(this.boardId);
    });
  }

  hideDialogClick(){
    if(this.hideDialogSection){
      this.hideDialogSection = false;
    }else{
      this.hideDialogSection = true;
    }
  }

  changeColors(i){
    this.selectedIndex = i;
  }

  changeFormatColors(i){
    this.selectedFormatIndex = i;
  }

  openUrlsDialog(modal, imgName: string, imgPosition: any, currentUrlId: any, format: any){
    this.plusButton = true;
    this.tagFieldArea = false;
    this.currentUrlsAssetId = currentUrlId
    this.imageUrlsHeading = imgName;
    this.currentUrlsIllusPosition = imgPosition;
    if(imgPosition == this.figmaLinksList.length-1) {
      this.showUrlsNextIcon = false;
      this.showUrlsPreviosIcon = true;
    } else if(imgPosition == 0){
      this.showUrlsPreviosIcon = false;
      this.showUrlsNextIcon = true;
    } else {
      this.showUrlsPreviosIcon = true;
      this.showUrlsNextIcon = true;
    }
    this.imgUrlsModal = this.modalService.open(modal, { centered: true, windowClass: 'urls-modal ' });
  }

  openImgDialog(modal, imgName: string, imgPosition: any,
    currentAssetId: any, format: any, currentVersion: any, boardId: any){
    this.getSuggestedTags(boardId, currentAssetId);
    this.hideEditImageName = true;
    this.hideEditFavImageName = true;
    this.suggestedTags = [];
    this.selectedVersion = currentVersion;
    this.addTagText = '';
    this.plusButton = true;
    this.tagFieldArea = false;
    this.imageHeading = imgName;
    this.favImageHeading = imgName;
    this.currentAssetId = currentAssetId
    this.currentIllusPosition = imgPosition;
    this.selectedFormatIndex = 0;
    this.imageDownloadShowFormat = "PNG";
    this.imageDownloadFormat = 'png';
    if(imgPosition == this.fileInfos.length-1) {
      this.showNextIcon = false;
      this.showPreviosIcon = true;
    } else if(imgPosition == 0){
      this.showPreviosIcon = false;
      this.showNextIcon = true;
    } else {
      this.showPreviosIcon = true;
      this.showNextIcon = true;
    }
    this.imgMainModal = this.modalService.open(modal, { centered: true, windowClass: 'svg-modal ' });
  }

  openImgSearchDialog(modal, currentImgPos: any, currentVersion: any,
    boardId: any, currentAssetId: any, imgName: string){
      this.suggestedTags = [];
    this.getSuggestedTags(boardId, currentAssetId);
    this.selectedVersion = currentVersion;
    this.imageHeading = imgName;
    this.favImageHeading = imgName;
    this.hideEditImageName = true;
    this.hideEditFavImageName = true;
    this.suggestedTags = [];
    this.addTagText = '';
    this.plusButton = true;
    this.tagFieldArea = false;
    this.selectedFormatIndex = 0;
    this.imageDownloadShowFormat = "PNG";
    this.imageDownloadFormat = 'png';
    this.currentIllusPosition = currentImgPos;
    this.currentSearchIllusPosition = currentImgPos;
    if(currentImgPos == this.imagesList.length-1) {
      this.showSearchNextIcon = false;
      this.showSearchPreviosIcon = true;
    } else if(currentImgPos == 0){
      this.showSearchPreviosIcon = false;
      this.showSearchNextIcon = true;
    } else {
      this.showSearchPreviosIcon = true;
      this.showSearchNextIcon = true;
    }
    this.imgSearchModal = this.modalService.open(modal, { centered: true, windowClass: 'svg-modal ' });
  }

  closeDownloadDialog(boardId: any){
    this.showRenameFormatAdd = false;
    this.showSmallImg = false;
    this.showDownloadDialog = false;
    this.closeImageEditField();
    this.showRenameFormatAdd = false;
    this.checkboxes.forEach((element) => {
      element.nativeElement.checked = false;
    });
    this.addedTagList = [];
    this.getImagesList(boardId);
  }

  closeUrlsDialog(boardId: any){
    this.checkboxes.forEach((element) => {
      element.nativeElement.checked = false;
    });
    this.addedUrlsTagList = [];
    this.listFigmaLinks(boardId);
  }

  closeDialogDownload(){
    this.showRenameFormatAdd = false;
    this.showDownloadDialog = false;
    this.checkboxes.forEach((element) => {
      element.nativeElement.checked = false;
    });
    this.addedTagList = [];
    // this.searchImages(this.searchText);
  }

  logOut(): void {
    this.authenticationService.logout();
    this.authService.signOut();
    this.router.navigate(['/home']);
  }

  getNotifications() {
    this.showLoader = true;
    this.newNotification ();
  }

  newNotification () {
    this.googleAnalyticsService.event('get_notifications_boards_screen_click', 'get_notifications_click', this.currentUser.firstName +" "+this.currentUser.lastName);
    this.damService.newNotifications(this.workspaceId).subscribe((data: any) => {
      this.notifications = data['notifcation'];
      this.showLoader = false;
    });
  }

  getName(fullEmail: string) {
    return fullEmail.split(' ').map(n => n[0]).join('').toUpperCase();
  }

  getRandomColor() {
    var color = Math.floor(0x1000000 * Math.random()).toString(16);
    return '#' + ('000000' + color).slice(-6);
  }

  hideSuccesfullFunction(){
    setTimeout(() => {
      this.sendSuccessful = false;
      this.showLinkCopied = false;
      this.sendSuccessfulToastMsg = false;
    }, 5000);
  }

  hideStatusDoneSuccesfullFunction(){
    setTimeout(() => {
      this.isShowLoadingStatusDone = false;
    }, 8000);
  }

  hideSuccesfullFunctionErrorDelete(){
    setTimeout(() => {
      this.sendSuccessfulErrorMsg = false;
    }, 5000);
  }

  verifyBoard(boardIds: any){
    this.sendSuccessful = false;
    this.showTopRightLoader = true;
    this.boardIdsList.push(boardIds);
    this.inboxService.verifyBoard(this.workspaceId, this.boardIdsList).subscribe((data: any) => {
      this.showTopRightLoader = false;
      this.sendSuccessful = true;
      this.successfullMessage = data.message;
      this.boardIdsList = [];
      this.hideSuccesfullFunction();
    },(error: any) => {
      if(error.status == 400){
        this.showTopRightLoader = false;
        this.sendSuccessfulErrorMsg = true;
        this.sendSuccessfulErrorMessage = error.error.message;
        this.boardIdsList = [];
        this.hideSuccesfullFunctionErrorDelete();
      } else {
        this.showTopRightLoader = false;
        this.sendSuccessfulErrorMsg = true;
        this.sendSuccessfulErrorMessage = error.error.message;
        this.boardIdsList = [];
        this.hideSuccesfullFunctionErrorDelete();
      }
   });
  }

  verifyAssets(assetsIds: any){
    this.sendSuccessful = false;
    this.showTopRightLoader = true;
    this.asssetsIdsList.push(assetsIds);
    this.inboxService.verifyAssets(this.workspaceId, this.asssetsIdsList).subscribe((data: any) => {
      this.showTopRightLoader = false;
      this.sendSuccessful = true;
      this.successfullMessage = data.message;
      this.asssetsIdsList = [];
      this.hideSuccesfullFunction();
    },(error: any) => {
      if(error.status == 400){
        this.showTopRightLoader = false;
        this.sendSuccessfulErrorMsg = true;
        this.sendSuccessfulErrorMessage = error.error.message;
        this.asssetsIdsList = [];
        this.hideSuccesfullFunctionErrorDelete();
      } else {
        this.showTopRightLoader = false;
        this.sendSuccessfulErrorMsg = true;
        this.sendSuccessfulErrorMessage = error.error.message;
        this.asssetsIdsList = [];
        this.hideSuccesfullFunctionErrorDelete();
      }
   });
  }

  verifyMultipleAssets(){
    this.showTopRightLoader = true;
    this.sendSuccessful = false;
    this.changeColor = [];
    this.imageSelected = false;
    this.downloadDelete = false;
    this.inboxService.verifyAssets(this.workspaceId, this.imagesIds).subscribe((data: any) => {
      this.sendSuccessful = true;
      this.showTopRightLoader = false;
      this.successfullMessage = data.message;
      this.asssetsIdsList = [];
      this.imagesIdList = [];
      this.imagesIds = [];
      this.count = 0;
      this.hideSuccesfullFunction();
    },(error: any) => {
      if(error.status == 400){
        this.hideContent();
        this.showTopRightLoader = false;
        this.sendSuccessfulErrorMsg = true;
        this.sendSuccessfulErrorMessage = error.error.message;
        this.asssetsIdsList = [];
        this.hideSuccesfullFunctionErrorDelete();
      } else if(error.status == 500) {
        this.hideContent();
        this.showTopRightLoader = false;
        this.sendSuccessfulErrorMsg = true;
        this.sendSuccessfulErrorMessage = "Assets are already verified!!";
        this.asssetsIdsList = [];
        this.hideSuccesfullFunctionErrorDelete();
      } else {
        this.hideContent();
        this.showTopRightLoader = false;
        this.sendSuccessfulErrorMsg = true;
        this.sendSuccessfulErrorMessage = error.error.message;
        this.asssetsIdsList = [];
        this.hideSuccesfullFunctionErrorDelete();
      }
   });
  }

  verifyBoardDialog() {

  }

  newCrafttorDummy(): void {

  }

  nextSearchImage(currentIllusPos: any) {
    this.showSearchNextIcon = true;
    this.showSearchPreviosIcon = true;
    this.selectedFormatIndex = 0;
    this.imageDownloadShowFormat = "PNG";
    this.imageDownloadFormat = 'png';
    this.showDownloadDialog = false;
    this.closeImageEditField();
    this.addedTagList = [];
    if(currentIllusPos == this.imagesList.length-2) {
      this.showSearchNextIcon = false;
    }
    if(currentIllusPos <= this.imagesList.length) {
      for(var i = 0 ; i < this.imagesList.length ; i++) {
        this.currentIllus = this.imagesList[currentIllusPos+1];
        this.selectedVersion = this.currentIllus.current_cover;
        this.imageHeading = this.currentIllus.title;
        this.favImageHeading = this.currentIllus.title;
        this.hideEditImageName = true;
        this.hideEditFavImageName = true;
      }
      this.currentIllus.is_fav = this.currentIllus.is_fav;
      this.suggestedTags = [];
      this.getSuggestedTags(this.currentIllus.board, this.currentIllus.id);
      this.commentsList = [];
      this.getAssetsComments(this.currentIllus.board, this.currentIllus.id);
      this.currentSearchIllusPosition = currentIllusPos+1;
    } else {
      //
    }
  }

  previousSearchImage(currentIllusPos: any) {
    this.showSearchNextIcon = true;
    this.showSearchPreviosIcon = true;
    this.selectedFormatIndex = 0;
    this.imageDownloadShowFormat = "PNG";
    this.imageDownloadFormat = 'png';
    this.showDownloadDialog = false;
    this.closeImageEditField();
    this.addedTagList = [];
    if(currentIllusPos == 0) {
      this.showSearchPreviosIcon = false;
    } else {
      for(var i = 0 ; i < this.imagesList.length ; i++) {
        this.currentIllus = this.imagesList[currentIllusPos-1];
        this.selectedVersion = this.currentIllus.current_cover;
        this.imageHeading = this.currentIllus.title;
        this.favImageHeading = this.currentIllus.title;
        this.hideEditImageName = true;
        this.hideEditFavImageName = true;
      }
      this.currentIllus.is_fav = this.currentIllus.is_fav;
      this.suggestedTags = [];
      this.getSuggestedTags(this.currentIllus.board, this.currentIllus.id);
      this.commentsList = [];
      this.getAssetsComments(this.currentIllus.board, this.currentIllus.id);
      this.currentSearchIllusPosition = currentIllusPos-1;
    }
  }

  nextUrlsImage(currentIllusPos: any) {
    this.showUrlsNextIcon = true;
    this.showUrlsPreviosIcon = true;
    this.addedUrlsTagList = [];
    this.closeImageEditField();
    if(currentIllusPos == this.fileInfos.length-2) {
      this.showNextIcon = false;
    }
    if(currentIllusPos <= this.figmaLinksList.length-2) {
      for(var i = 0 ; i < this.figmaLinksList.length ; i++) {
        this.currentUrlsIllus = this.figmaLinksList[currentIllusPos+1];
        this.imageHeading = this.currentIllus.title;
        this.favImageHeading = this.currentIllus.title;
        this.hideEditImageName = true;
        this.hideEditFavImageName = true;
      }
      this.commentsList = [];
      this.getAssetsComments(this.currentUrlsIllus.board, this.currentUrlsIllus.id);
      this.currentUrlsIllusPosition = currentIllusPos+1;
    } else {
      //
    }
  }

  previousUrlsImage(currentIllusPos: any) {
    this.showUrlsNextIcon = true;
    this.showUrlsPreviosIcon = true;
    this.addedUrlsTagList = [];
    this.closeImageEditField();
    if(currentIllusPos == 0) {
      this.showUrlsPreviosIcon = false;
    } else {
      for(var i = 0 ; i < this.figmaLinksList.length ; i++) {
        this.currentUrlsIllus = this.figmaLinksList[currentIllusPos-1];
        this.imageHeading = this.currentIllus.title;
        this.favImageHeading = this.currentIllus.title;
        this.hideEditImageName = true;
        this.hideEditFavImageName = true;
      }
      this.commentsList = [];
      this.getAssetsComments(this.currentUrlsIllus.board, this.currentUrlsIllus.id);
      this.currentUrlsIllusPosition = currentIllusPos-1;
    }
  }

  nextImage(currentIllusPos: any) {
    this.showNextIcon = true;
    this.showPreviosIcon = true;
    this.selectedFormatIndex = 0;
    this.imageDownloadShowFormat = "PNG";
    this.imageDownloadFormat = 'png';
    this.showDownloadDialog = false;
    this.closeImageEditField();
    this.showRenameFormatAdd = false;
    this.addedTagList = [];
    if(currentIllusPos == this.fileInfos.length-2) {
      this.showNextIcon = false;
    }
    if(currentIllusPos <= this.fileInfos.length-2) {
      for(var i = 0 ; i < this.fileInfos.length ; i++) {
        this.currentIllus = this.fileInfos[currentIllusPos+1];
        this.selectedVersion = this.currentIllus.current_cover;
        this.imageHeading = this.currentIllus.title;
        this.favImageHeading = this.currentIllus.title;
        this.hideEditImageName = true;
        this.hideEditFavImageName = true;
        this.isFav = false;
      }
      this.suggestedTags = [];
      this.getSuggestedTags(this.currentIllus.board, this.currentIllus.id);
      this.commentsList = [];
      this.getAssetsComments(this.currentIllus.board, this.currentIllus.id);
      this.currentIllusPosition = currentIllusPos+1;
    } else {
      //
    }
  }

  previousImage(currentIllusPos: any) {
    this.showNextIcon = true;
    this.showPreviosIcon = true;
    this.selectedFormatIndex = 0;
    this.imageDownloadShowFormat = "PNG";
    this.imageDownloadFormat = 'png';
    this.showDownloadDialog = false;
    this.closeImageEditField();
    this.showRenameFormatAdd = false;
    this.addedTagList = [];
    if(currentIllusPos == 0) {
      this.showPreviosIcon = false;
    } else {
      for(var i = 0 ; i < this.fileInfos.length ; i++) {
        this.currentIllus = this.fileInfos[currentIllusPos-1];
        this.selectedVersion = this.currentIllus.current_cover;
        this.imageHeading = this.currentIllus.title;
        this.favImageHeading = this.currentIllus.title;
        this.hideEditImageName = true;
        this.hideEditFavImageName = true;
        this.isFav = false;
      }
      this.suggestedTags = [];
      this.getSuggestedTags(this.currentIllus.board, this.currentIllus.id);
      this.commentsList = [];
      this.getAssetsComments(this.currentIllus.board, this.currentIllus.id);
      this.currentIllusPosition = currentIllusPos-1;
    }
  }

  closeShareLinkStyle() {
    this.imagesIds = [];
    this.shareImageLink = "";
    this.shareLinkStyle = "none";
  }

  showGeneratedLink() {
    this.isShowShareLinkGenerated = true;
  }

  copyShareLink(inputElement){
    if(this.allowDownloadSelected) {
      this.allowDownloads = 1;
    } else {
      this.allowDownloads = 0;
    }

    if(this.showCommentSelected) {
      this.showComments = 1;
    } else {
      this.showComments = 0;
    }

    if(this.allowCommentingSelected) {
      this.allowComments = 1;
    } else {
      this.allowComments = 0;
    }

    if(this.fromAssets) {
      this.subscriptionService.shareAssetsSettingsData(this.sharedToken,
        this.allowDownloads, this.expiryLinkIn, this.showComments, this.allowComments).subscribe((data) => {

      },(error: any) => {
        if(error.status == 400){
          this.sendSuccessfulErrorMsg = true;
          this.sendSuccessfulErrorMessage = error.error.message;
          this.hideSuccesfullFunctionErrorDelete();
        } else {
          this.sendSuccessfulErrorMsg = true;
          this.sendSuccessfulErrorMessage = error.error.message;
          this.hideSuccesfullFunctionErrorDelete();
        }
      });
    } else {
      this.subscriptionService.shareBoardsSettingsData(this.sharedToken,
        this.allowDownloads, this.expiryLinkIn, this.showComments, this.allowComments).subscribe((data) => {

      },(error: any) => {
        if(error.status == 400){
          this.sendSuccessfulErrorMsg = true;
          this.sendSuccessfulErrorMessage = error.error.message;
          this.hideSuccesfullFunctionErrorDelete();
        } else {
          this.sendSuccessfulErrorMsg = true;
          this.sendSuccessfulErrorMessage = error.error.message;
          this.hideSuccesfullFunctionErrorDelete();
        }
      });
    }
    inputElement.select();
    document.execCommand('copy');
    inputElement.setSelectionRange(0, 0);
    this.showLinkCopied = true;
    this.hideSuccesfullFunction();
    // this.alert.message("copied");
  }

  openFigmaLinkDialog() {
    this.shareFigmaLinkStyle = "block";
  }

  closeFigmaLinkDialog() {
    this.addingFigmaLinkLoader = false;
    this.shareFigmaLinkStyle = "none";
  }

  checkFieldEmpty() {
    if(this.figmaAddLink == '') {
      this.invalid = false;
    } else {
      this.invalid = true;
    }
  }

  addFigmaLink() {
    this.figmaErrorMsg = "";
    // if(this.figmaAddLink.includes("https://www.figma.com/")) {
      this.uploadFigmaLink(this.figmaAddLink);
    // } else {
    //   this.figmaErrorMsg = "Invalid link";
    // }
  }

  openShareLinkStyle(imgId: any, imgLink: any) {
    this.fromAssets = true;
    this.shareImageLink = imgLink;
    this.hitShareApi(imgId);
  }

  shareMultipleAssets() {
    this.fromAssets = true;
    this.hitShareMultipleApi(this.imagesIds);
  }

  hitShareApi(imgId: any) {
    this.subscriptionService.hitShare(this.workspaceId, this.boardId, imgId, "").subscribe((data) => {
      this.shareableLink = data.link;
      this.sharedToken = data.token;
      this.shareLinkStyle = "block";
      this.hideContent();
    },(error: any) => {
      if(error.status == 400){
        this.hideContent();
        this.sendSuccessfulErrorMsg = true
        this.sendSuccessfulErrorMessage = error.error.message;
        this.hideSuccesfullFunctionErrorDelete();
      } else {
        this.hideContent();
        this.sendSuccessfulErrorMsg = true
        this.sendSuccessfulErrorMessage = error.error.message;
        this.hideSuccesfullFunctionErrorDelete();
      }
   });
  }

  hitSharePopUpApi(imgId: any) {
    this.subscriptionService.hitShare(this.workspaceId, this.boardId, imgId, "").subscribe((data) => {
      this.shareableLink = data.link;
      this.sharedToken = data.token;
      this.hideContent();
    },(error: any) => {
      if(error.status == 400){
        this.hideContent();
        this.sendSuccessfulErrorMsg = true
        this.sendSuccessfulErrorMessage = error.error.message;
        this.hideSuccesfullFunctionErrorDelete();
      } else {
        this.hideContent();
        this.sendSuccessfulErrorMsg = true
        this.sendSuccessfulErrorMessage = error.error.message;
        this.hideSuccesfullFunctionErrorDelete();
      }
   });
  }

  hitShareMultipleApi(imgId: any) {
    this.subscriptionService.hitMultipleShare(this.workspaceId, this.boardId, imgId, "").subscribe((data) => {
      this.shareableLink = data.link;
      this.sharedToken = data.token;
      this.shareLinkStyle = "block";
      this.hideContent();
    },(error: any) => {
      this.hideContent();
      if(error.status == 400){
        this.sendSuccessfulErrorMsg = true
        this.sendSuccessfulErrorMessage = error.error.message;
        this.hideSuccesfullFunctionErrorDelete();
      } else {
        this.sendSuccessfulErrorMsg = true
        this.sendSuccessfulErrorMessage = error.error.message;
        this.hideSuccesfullFunctionErrorDelete();
      }
   });
  }

  shareBoard() {
    this.fromAssets = false;
    this.shareImageLink = "";
    this.hitShareBoardApi();
  }

  hitShareBoardApi() {
    this.subscriptionService.hitBoardShare(this.workspaceId, this.boardId, "").subscribe((data) => {
      this.shareableLink = data.link;
      this.sharedToken = data.token;
      this.shareLinkStyle = "block";
      this.hideContent();
    },(error: any) => {
      this.hideContent();
      if(error.status == 400){
        this.sendSuccessfulErrorMsg = true
        this.sendSuccessfulErrorMessage = error.error.message;
        this.hideSuccesfullFunctionErrorDelete();
      } else {
        this.sendSuccessfulErrorMsg = true
        this.sendSuccessfulErrorMessage = error.error.message;
        this.hideSuccesfullFunctionErrorDelete();
      }
   });
  }

  hideContent() {
    this.imagesIdList = [];
    this.imagesIds = [];
    this.changeColor = [];
    this.imageSelected = false;
    this.downloadDelete = false;
    this.count = 0;
  }

  goToMarketplace() {
    window.open("https://crafttor.com/marketplace", "_blank");
  }

  goToFeedback() {
    window.open("https://workspace.crafttor.com/feedbacks", "_blank");
  }

  onSubmitReplyComment(imgId: any, commentId: any, replyMsg: any, boardId: any) {
    if(this.userSelectedForReplyTag) {
      this.taggingComments(boardId, imgId, commentId, replyMsg, this.selectedUserIdForTag)
    } else {
      this.postAssetsReplyComments(imgId, commentId, replyMsg);
    }
  }

  onSubmitCommentSection(imgId: any, mainMsg: any, boardId: any) {
    if(this.userSelectedForTag) {
      this.taggingComments(boardId, imgId, "", mainMsg, this.selectedUserIdForTag)
    } else {
      this.postAssetsComments(imgId, mainMsg);
    }
  }

  postAssetsComments(imageId: any, mainMsg: any) {
    this.openEditBox = false;
    if (this.mainMsgForm.valid) {
      this.showChatLoader = true;
      this.damService.postAssetComment(this.workspaceId, this.boardId, imageId,
        this.commentId, mainMsg).subscribe((data) => {
          this.selectedUserIdForTag = "";
          this.showChatLoader = false;
          this.commentMsg = "";
          this.replyMsg = "";
          this.textArea = "";
          this.replyForm.reset();
          this.mainMsgForm.reset();
          this.getAssetsComments(this.boardId, imageId);
      },
      (error: any) => {
        if(error.status == 400 || error.status == 403){
        } else {
          // this.getUnResolveComments(this.boardId, imageId);
        }
     });
    }
  }

  postAssetsReplyComments(imageId: any, commentId: any, replyMsg: any) {
    this.openEditBox = false;
    this.submitted = true;
    if (this.replyForm.valid) {
      this.damService.postAssetComment(this.workspaceId, this.boardId, imageId,
        commentId, replyMsg).subscribe((data) => {
          this.selectedUserIdForTag = "";
          this.commentMsg = "";
          this.replyMsg = "";
          this.replyArea = "";
          this.replyForm.reset();
          this.mainMsgForm.reset();
          this.getAssetsComments(this.boardId, imageId);
      },
      (error: any) => {
        if(error.status == 400 || error.status == 403){
          // this.getUnResolveComments(this.boardId, imageId);
        } else {
          // this.getUnResolveComments(this.boardId, imageId);
        }
     });
    }
  }

  getAssetsCommentsData(boardId: any, assetId: any) {
    this.getAssetsComments(boardId, assetId);
    this.getAllUsersList();
  }

  getAssetsComments(boardId: any, assetId: any) {
    this.openEditBox = false;
    this.damService.getAssetComment(this.workspaceId, boardId, assetId).subscribe((data) => {
        this.commentsList = data['results'];
        this.noComments = "No comments!!";
    });
  }

  getAllUsersList() {
    this.damService.getAllUsersList(this.workspaceId).subscribe((data: any) => {
      this.usersList = data;
    });
  }

  getInitial(fullEmail: string) {
    const words = fullEmail.split(' ');
    let initials = '';

    if (words.length > 2) {
      initials = words.slice(0, 2).map(word => word.charAt(0)).join('').toUpperCase();
    } else {
      initials = words.map(word => word.charAt(0)).join('').toUpperCase();
    }

    return initials;
   }

  deleteComments(boardId: any, assetId: any, commentId: any) {
    this.openEditBox = false;
    this.damService.deleteAssetComment(this.workspaceId, boardId, assetId, commentId).subscribe((data) => {
      this.getAssetsComments(boardId, assetId);
    });
  }

  public editComments(boardId: any, assetId: any, commentId: any) {
    this.submitted = true;
    if (this.commentForm.valid) {
      this.damService.editAssetComment(this.workspaceId, boardId, assetId, commentId,
        this.commentForm.value.comment).subscribe((data) => {
        this.openEditBox = false;
        this.editComment = "";
        this.commentForm.value.comment = "";
        this.getAssetsComments(boardId, assetId);
      });
    }
  }

  public getUnResolveComments(boardId: any, assetId: any) {
    this.openEditBox = false;
    this.damService.unResolveComment(this.workspaceId, boardId, assetId).subscribe((data) => {
      this.commentsList = data['results'];
      this.noComments = "No open comments!!";
    });
  }

  public resolvedListComments(boardId: any, assetId: any) {
    this.openEditBox = false;
    this.damService.resolvedListComment(this.workspaceId, boardId, assetId).subscribe((data) => {
      this.commentsList = data['results'];
      this.noComments = "No resolved comments!!";
    });
  }

  public postResolvedComments(boardId: any, assetId: any, commentId: any) {
    this.openEditBox = false;
    this.damService.resolvedComment(this.workspaceId, boardId, assetId, commentId).subscribe((data) => {
      this.getUnResolveComments(boardId, assetId);
    });
  }

  public taggingComments(boardId: any, assetId: any, commentId: any, commentMsg: any, userId: any) {
    this.openEditBox = false;
    if(commentMsg != "" || commentMsg != null) {
      this.showChatLoader = true;
      this.damService.taggingComment(this.workspaceId, boardId, assetId,
        commentId, commentMsg, userId).subscribe((data) => {
          this.selectedUserIdForTag = "";
          this.showChatLoader = false;
          this.commentMsg = "";
          this.replyMsg = "";
          this.textArea = "";
          this.replyArea = "";
          this.replyForm.reset();
          this.mainMsgForm.reset();
          this.getAssetsComments(this.boardId, assetId);
      });
    }
  }

  openEditComment () {
    this.showChatLoader = false;
    this.replyMsg = "";
    this.replyArea = "";
    this.replyForm.reset();
    this.openEditBox = true;
  }

  openReplyBoxes(index) {
    this.showChatLoader = false;
    this.replyMsg = "";
    this.replyArea = "";
    this.replyForm.reset();
    this.index = index;
  }

  showDownloadPopup() {
    if(this.showDownloadDialog == true) {
      this.showDownloadDialog = false;
    } else if(this.showDownloadDialog == false){
      this.showDownloadDialog = true;
    }
  }

  public isEmojiPickerVisible: boolean;
  @ViewChild("mainMsgData") commentField;

  public addEmoji(event) {
    this.textArea = `${this.textArea}${event.emoji.native}`;
    this.isEmojiPickerVisible = false;
    this.commentField.nativeElement.focus();
  }

  public isEmojiPickerVisibleReply: boolean;
  @ViewChild("replyData") replyField;

  public addReplyEmoji(event) {
    this.replyArea = `${this.replyArea}${event.emoji.native}`;
    this.isEmojiPickerVisible = false;
  }

  @ViewChild('scrollMe') private myScrollContainer: ElementRef;
  scrollToBottom(): void {
        try {
            this.myScrollContainer.nativeElement.scrollTop = this.myScrollContainer.nativeElement.scrollHeight;
        } catch(err) { }
  }

  @ViewChild(PdfViewerComponent, {static: false})
  private pdfComponent: PdfViewerComponent;
  pageRendered() {
    this.pdfComponent.pdfViewer.currentScaleValue = 'page-fit';
  }

  deleteImageVersion(currentIllusPos: any, version: any, boardId: any, imageId: any) {
    this.damService.deleteImageVersion(this.workspaceId, boardId, imageId, version).subscribe((data: any) => {
      this.uploadService.getFiles(this.workspaceId, this.boardId).subscribe((data: any) => {
        this.fileInfos = data['results'];
        this.totalIllusCount = data['results'].length;

        for(var i = 0 ; i < this.fileInfos.length ; i++) {
          this.currentIllus = this.fileInfos[currentIllusPos];
        }
      });
    },
    (error) => {
      if(error.status == 403 || error.status == 401 || error.status == 400){
        this.sendSuccessfulErrorMsg = true
        this.sendSuccessfulErrorMessage = error.error.message;
        this.hideSuccesfullFunctionErrorDelete();
      } else {
        this.sendSuccessfulErrorMsg = true
        this.sendSuccessfulErrorMessage = error.error.message;
        this.hideSuccesfullFunctionErrorDelete();
      }
   });
  }

  deleteSearchImageVersion(currentIllusPos: any, version: any, boardId: any, imageId: any) {
    this.damService.deleteImageVersion(this.workspaceId, boardId, imageId, version).subscribe((data: any) => {
      this.damService.searchImages(this.workspaceId, this.searchTextSet).subscribe((data: any) => {
        this.imagesList = data.image;
        this.searchData = this.searchText;
        this.boardImagesSection = false;
        this.searchImageslistSection = true;
        this.selectedVersion = version;
        for(var i = 0 ; i < this.imagesList.length ; i++) {
          this.currentIllus = this.imagesList[currentIllusPos];
        }
      });
    },
    (error) => {
      if(error.status == 403 || error.status == 401 || error.status == 400){
        this.sendSuccessfulErrorMsg = true
        this.sendSuccessfulErrorMessage = error.error.message;
        this.hideSuccesfullFunctionErrorDelete();
      } else {
        this.sendSuccessfulErrorMsg = true
        this.sendSuccessfulErrorMessage = error.error.message;
        this.hideSuccesfullFunctionErrorDelete();
      }
   });
  }

  makeCoverImageVersion(currentIllusPos: any, version: any, boardId: any, imageId: any) {
    this.damService.makeCoverImageVersion(this.workspaceId, boardId, imageId, version).subscribe((data: any) => {
      this.uploadService.getFiles(this.workspaceId, this.boardId).subscribe((data: any) => {
        this.fileInfos = data['results'];
        this.totalIllusCount = data['results'].length;
        this.selectedVersion = version;
        for(var i = 0 ; i < this.fileInfos.length ; i++) {
          this.currentIllus = this.fileInfos[currentIllusPos];
        }
      });
    },
    (error) => {
      if(error.status == 403 || error.status == 401 || error.status == 400){
        this.sendSuccessfulErrorMsg = true
        this.sendSuccessfulErrorMessage = error.error.message;
        this.hideSuccesfullFunctionErrorDelete();
      } else {
        this.sendSuccessfulErrorMsg = true
        this.sendSuccessfulErrorMessage = error.error.message;
        this.hideSuccesfullFunctionErrorDelete();
      }
   });
  }

  makeSearchCoverImageVersion(currentIllusPos: any, version: any, boardId: any, imageId: any) {
    this.damService.makeCoverImageVersion(this.workspaceId, boardId, imageId, version).subscribe((data: any) => {
      this.damService.searchImages(this.workspaceId, this.searchTextSet).subscribe((data: any) => {
        this.imagesList = data.image;
        this.searchData = this.searchText;
        this.boardImagesSection = false;
        this.searchImageslistSection = true;
        this.selectedVersion = version;
        for(var i = 0 ; i < this.imagesList.length ; i++) {
          this.currentIllus = this.imagesList[currentIllusPos];
        }
      });
    },
    (error) => {
      if(error.status == 403 || error.status == 401 || error.status == 400){
        this.sendSuccessfulErrorMsg = true
        this.sendSuccessfulErrorMessage = error.error.message;
        this.hideSuccesfullFunctionErrorDelete();
      } else {
        this.sendSuccessfulErrorMsg = true
        this.sendSuccessfulErrorMessage = error.error.message;
        this.hideSuccesfullFunctionErrorDelete();
      }
   });
  }

  selectFilesVersion(fromDialog: any, event, currentIllusPos: any, boardHeading: string, boardId: any, imageId: any): void {
    this.progressInfos = [];
    this.replaceAsset = true;

    const files = event.target.files;
    let isImage = true;
    for (let i = 0; i < files.length; i++) {
      if (files.item(i).type.match('pdf.*') || files.item(i).type.match('image.*') || files.item(i).type.match('video.*')) {
        continue;
      } else {
        isImage = false;
        alert('Invalid Format!');
        break;
      }
    }

    if (isImage) {
      this.selectedFiles = event.target.files;
      this.uploadFilesVersion(fromDialog, event, currentIllusPos, boardHeading, boardId, imageId);
    } else {
      this.selectedFiles = undefined;
      event.srcElement.percentage = null;
    }
  }

  uploadFilesVersion(fromDialog: any, event, currentIllusPos, boardHeading: string, boardId: any, imageId: any): void {
    this.message = '';
    for (let i = 0; i < this.selectedFiles.length; i++) {
      // this.getImageResolution(this.selectedFiles[i], i, );
      this.addVersionImage(fromDialog, i, currentIllusPos, this.selectedFiles[i], boardHeading, boardId, imageId);
    }
  }

  addVersionImage(fromDialog: any, idx, currentIllusPos: any, file, boardHeading: string, boardId: any, imageId: any): void {
    this.progressInfos[idx] = { value: 0, fileName: file.name };
    this.uploadService.uploadImageVersion(file, file.name, boardHeading, boardId, this.workspaceId, imageId).subscribe(
      event => {
        if (event.type === HttpEventType.UploadProgress) {
          this.progressInfos[idx].percentage = Math.round(100 * event.loaded / event.total);
          this.progressPecentage = this.progressInfos[idx].percentage;
        } else if (event instanceof HttpResponse) {
          if(fromDialog == 'mainDialog') {
            this.uploadService.getFiles(this.workspaceId, boardId).subscribe((data: any) => {
            this.fileInfos = data['results'];
            this.totalIllusCount = data['results'].length;
            for(var i = 0 ; i < this.fileInfos.length ; i++) {
              this.currentIllus = this.fileInfos[currentIllusPos];
            }
            this.imageExtensionApi();
          });
        } else if(fromDialog == 'searchDialog') {
            this.damService.searchImages(this.workspaceId, this.searchTextSet).subscribe((data: any) => {
              this.imagesList = data.image;
              this.searchData = this.searchText;
              this.boardImagesSection = false;
              this.searchImageslistSection = true;
              for(var i = 0 ; i < this.imagesList.length ; i++) {
                this.currentIllus = this.imagesList[currentIllusPos];
              }
            });
          }
        }
      },
      (error: any) => {
        if(error.status == 400){
          this.isShowLoadingStatusDone = false;
          this.isShowLoadingStatus = false;
          this.uploadedFileName = error.error.title.title;
          this.openUploadOptionsStyleBoard();
        } else {
          this.isShowLoadingStatusDone = false;
          this.isShowLoadingStatus = false;
          this.sendSuccessfulErrorMsg = true
          this.sendSuccessfulErrorMessage = error.error.message;
          this.hideSuccesfullFunctionErrorDelete();
        }
     }
    );
  }

  setMainImage(imgLink: any, version: any) {
    this.selectedVersion = version;
    this.currentIllus.image = imgLink;
  }

  downloadVersionImage(currentImageId: any, titleImage: string, boardId: any, version: any): void {
    this.damService.downloadVersionImages(this.workspaceId, boardId, currentImageId, version).subscribe((data: any) => {
      saveAs(data, titleImage)
    },
      (error: any) => {
        if (error.status == 403) {
          // this.openLimitModal(this.limitModal);
        }
        else {
          // this.alert.alert("Alert", "Limit reached! Please login to download")
        }
      }
    );
  }

  openVersionImages() {
    this.showSmallImg = true;
  }

  closeVersionImages() {
    this.showSmallImg = false;
  }

  openFigma() {
    this.googleAnalyticsService.event('figma_boards_screen', 'figma_icon', this.currentUser.firstName +" "+this.currentUser.lastName);
    window.open("https://www.figma.com/community/plugin/902086023682633830/Crafttor", "_blank");
  }

  openSketch() {
    this.googleAnalyticsService.event('sketch_boards_screen', 'sketch_icon', this.currentUser.firstName +" "+this.currentUser.lastName);
    window.open("https://crafttor.com/sketch", "_blank");
  }

  openIllustrator() {
    this.googleAnalyticsService.event('ai_boards_screen', 'ai_icon', this.currentUser.firstName +" "+this.currentUser.lastName);
    window.open("https://exchange.adobe.com/apps/cc/109306/crafttor-for-illustrator", "_blank");
  }

  hitUsersListApi(event) {
    if(event.target.value === "@") {
      this.showUsersListDialog = true;
    } else if(event.target.value === "") {
      this.selectedUserIdForTag = "";
      this.showUsersListDialog = false;
      this.userSelectedForTag = false;
    } else {
      this.showUsersListDialog = false;
    }
  }

  selectedTagUser(userId: any, userFirstName: string) {
    this.showUsersListDialog = false;
    this.userSelectedForTag = true;
    this.selectedUserIdForTag = userId;
    this.textArea = userFirstName;
    this.selectedUserNameForTag = userFirstName;
  }

  hitUsersListReplyApi(event) {
    if(event.target.value === "@") {
      this.showUsersListReplyDialog = true;
    } else if(event.target.value === "") {
      this.selectedUserIdForTag = "";
      this.showUsersListReplyDialog = false;
      this.userSelectedForReplyTag = false;
    } else {
      this.showUsersListReplyDialog = false;
    }
  }

  selectedReplyTagUser(userId: any, userFirstName: string) {
    this.showUsersListReplyDialog = false;
    this.userSelectedForReplyTag = true;
    this.selectedUserIdForTag = userId;
    this.replyArea = userFirstName;
  }

  resetFields() {
    this.commentMsg = "";
    this.replyMsg = "";
    this.textArea = "";
    this.replyArea = "";
    this.replyForm.reset();
    this.mainMsgForm.reset();
  }

  uploadFigmaLink(fileLink: any) {
    this.addingFigmaLinkLoader = true;
    this.uploadService.uploadFigmaFile(fileLink, this.boardId, this.workspaceId).subscribe((data: any) => {
      this.figmaLinksList = data['results'];
      this.addingFigmaLinkLoader = false;
      this.closeFigmaLinkDialog();
      this.listFigmaLinks(this.boardId);
    },(error: any) => {
      if(error.status == 403 || error.status == 400){
        this.sendSuccessfulErrorMsg = true;
        this.sendSuccessfulErrorMessage = error.error.message;
        this.hideSuccesfullFunctionErrorDelete();
      } else {
        this.sendSuccessfulErrorMsg = true;
        this.sendSuccessfulErrorMessage = error.error.message;
        this.hideSuccesfullFunctionErrorDelete();
      }
    });
  }

  figmaUrl: SafeResourceUrl | null = null;

  listFigmaLinks(boardId: any) {
    this.damService.getFigmaLinks(this.workspaceId, boardId).subscribe((data: any) => {
      this.figmaLinksList = data['results'];
      // for (let i = 0; i < this.figmaLinksList.length; i++) {
      //   const figmaUrls = this.figmaLinksList[i].figma_link;
      //   this.figmaUrl = this.sanitizer.bypassSecurityTrustResourceUrl(figmaUrls);
      //
      // }

    },(error: any) => {
      if(error.status == 403 || error.status == 400){
        this.sendSuccessfulErrorMsg = true;
        this.sendSuccessfulErrorMessage = error.error.message;
        this.hideSuccesfullFunctionErrorDelete();
      } else {
        this.sendSuccessfulErrorMsg = true;
        this.sendSuccessfulErrorMessage = error.error.message;
        this.hideSuccesfullFunctionErrorDelete();
      }
    });
  }

  trashFigmaLink(figmaId: any) {
    this.damService.trashFigmaLinks(this.workspaceId, this.boardId, figmaId).subscribe((data: any) => {
      this.listFigmaLinks(this.boardId);
    },(error: any) => {
      if(error.status == 403 || error.status == 400){
        this.sendSuccessfulErrorMsg = true;
        this.sendSuccessfulErrorMessage = error.error.message;
        this.hideSuccesfullFunctionErrorDelete();
      } else {
        this.sendSuccessfulErrorMsg = true;
        this.sendSuccessfulErrorMessage = error.error.message;
        this.hideSuccesfullFunctionErrorDelete();
      }
    });
  }

  addFigmaTagsList() {
    this.addTagText = '';
    this.plusButton = false;
    this.tagFieldArea = true;
    this.damService.addFigmaLinkTags(this.workspaceId, this.boardId, this.currentIllus.id,
      "addTagText").subscribe((data: any) => {
        this.addedTag = data.tag;
        this.addedTagList.push({tags: this.addedTag});
    });
  }

  figmaLinkRedirect(figmaLink: any) {
    window.open(figmaLink, "_blank");
  }

  pinBoard(boardId: any) {
    this.damService.pinBoards(this.workspaceId, boardId).subscribe((data: any) => {
        this.getBoardsList();
    },
    (error) => {
      if(error.status == 400){
        this.sendSuccessfulErrorMsg = true;
        this.sendSuccessfulErrorMessage = error.error.message;
        this.hideSuccesfullFunctionErrorDelete();
      } else {
        this.sendSuccessfulErrorMsg = true;
        this.sendSuccessfulErrorMessage = error.error.message;
        this.hideSuccesfullFunctionErrorDelete();
      }
    });
  }

  unPinBoard(boardId: any) {
    this.damService.unPinBoards(this.workspaceId, boardId).subscribe((data: any) => {
        this.getBoardsList();
    },
    (error) => {
      if(error.status == 400){
        this.sendSuccessfulErrorMsg = true;
        this.sendSuccessfulErrorMessage = error.error.message;
        this.hideSuccesfullFunctionErrorDelete();
      } else {
        this.sendSuccessfulErrorMsg = true;
        this.sendSuccessfulErrorMessage = error.error.message;
        this.hideSuccesfullFunctionErrorDelete();
      }
    });
  }

  onSubmit() {
    if(this.searchText.length > 0) {
      this.searchTerms.push(this.searchText);
      this.searchArrayImages(this.searchText, this.searchTerms);
    }
  }

  searchArrayImages(searchText: any, searchTermArray: any){
    this.downloadDelete = false;
    this.imagesIdList = [];
    this.changeColor = [];
    this.imageSelected = false;
    this.searchTextSet = searchText;
    this.damService.searchImagesArray(this.workspaceId, searchTermArray).subscribe((data: any) => {
      this.searchText = "";
      this.imagesList = data.image;
      this.searchData = '' + this.searchTextSet;
      this.boardImagesSection = false;
      this.searchImageslistSection = true;
    });
  }

  removeSearchTerm(index: number, searchTerm: any) {
    this.searchTerms.splice(index, 1);
    if(this.searchTerms.length > 0) {
      this.searchArrayImages(searchTerm, this.searchTerms);
    } else {
      this.boardImagesSection = false;
      this.searchImageslistSection = true;
      this.imagesList = [];
    }
  }

  archiveSingleSearchImage(imgId: any, pos: any, boardId: any,
    fromWhichSection: any, imgTitle: any) {
    this.showTopRightLoader = true;
    this.damService.archiveSingleImages(this.workspaceId, boardId, imgId).subscribe((data: any) => {
      if(fromWhichSection == 'table') {
        this.showtableViewData = true;
        this.showNestedViewData = false;
        this.getImagesList(boardId);
      } else if(fromWhichSection == 'search') {
        this.searchArrayImages(this.searchText, this.searchTerms);
      }
      this.showTopRightLoader = false;
      this.sendSuccessful = true;
      this.successfullMessage = imgTitle + " moved to trash";
      this.hideSuccesfullFunction();
    });
  }

  allowDownload() {
    if(this.allowDownloadSelected) {
      this.allowDownloadSelected = false;
    } else {
      this.allowDownloadSelected = true;
    }
  }

  allowShowComments() {

  }

  allowCommenting() {

  }

  selectExpireLink (event: any) {
    this.expiryLinkIn = event.target.value;
  }

  openFigmaRenameDialog(figmaId: any, figmaName: any, figmaBoardId: any) {
    this.renameFigmaErrorMsg = "";
    this.figmaId = figmaId;
    this.figmaBoardId = figmaBoardId;
    this.figmaCurrentName = figmaName;
    this.figmaRenameStyle = "block";
  }

  closeFigmaRenameDialog() {
    this.renameFigmaErrorMsg = "";
    this.figmaRenameStyle = "none";
  }

  renameFigmaLinks() {
    this.showRenameLoader = true;
    this.renameFigmaErrorMsg = "";
    this.damService.renameFigmaLinks(this.workspaceId, this.figmaBoardId, this.figmaId, this.figmaNewName).subscribe((data: any) => {
      this.figmaLinksList = data['results'];
      this.closeFigmaRenameDialog();
      this.sendSuccessful = true;
      this.successfullMessage = "Renamed " + this.figmaCurrentName + " to " +this.figmaNewName;
      this.hideSuccesfullFunction();
      this.listFigmaLinks(this.figmaBoardId);
    },(error: any) => {
      if(error.status == 403 || error.status == 400){
        this.showRenameLoader = false;
        this.renameFigmaErrorMsg = error.error.message;
      } else {
        this.showRenameLoader = false;
        this.renameFigmaErrorMsg = error.error.message;
      }
    });
  }

  openAssetRenameDialog(assetId: any, currentName: any, boardId: any,
    componentCheck: any, imageLink: any) {
    this.renameImageLink = imageLink;
    this.renameErrorMsg = "";
    this.mainComponent = componentCheck;
    this.assetCurrentId = assetId;
    this.assetCurrentName = currentName;
    this.renameBoardId = boardId;
    this.assetRenameStyle = "block";
  }

  closeAssetRenameDialog() {
    this.renameErrorMsg = "";
    this.assetRenameStyle = "none";
  }

  assetRename() {
    this.renameErrorMsg = "";
    this.showRenameLoader = true;
    this.damService.changeImageNameApi(this.workspaceId, this.renameBoardId, this.assetCurrentId, this.assetNewName).subscribe((data: any) => {
      this.renameImageLink = "";
      this.assetRenameStyle = "none";
      this.showRenameLoader = false;
      this.sendSuccessful = true;
      this.successfullMessage = "Renamed " + this.assetCurrentName + " to " +this.assetNewName;
      this.hideSuccesfullFunction();
      if(this.mainComponent == 'nested') {
        this.showtableViewData = false;
        this.showNestedViewData = true;
        this.isTableSelected = false;
        this.isNestedSelected = true;
        this.boardImagesSection = true;
        this.searchImageslistSection = false;
        this.getImagesList(this.renameBoardId);
      } else if(this.mainComponent == 'table') {
        this.showtableViewData = true;
        this.showNestedViewData = false;
        this.isTableSelected = true;
        this.isNestedSelected = false;
        this.boardImagesSection = true;
        this.searchImageslistSection = false;
        this.getImagesList(this.renameBoardId);
      } else if(this.mainComponent == 'search') {
        this.searchArrayImages(this.searchText, this.searchTerms);
      }
    },
    (error: any) => {
      if(error.status == 403 || error.status == 400){
        this.showRenameLoader = false;
        this.renameErrorMsg = error.error.message;
      } else {
        this.showRenameLoader = false;
        this.renameErrorMsg = error.error.message;
      }
   });
  }

  openEditTagsDialog(assetId: any, currentName: any, imageLink: any,
    boardId: any, componentCheck: any, imgFormat: any) {
    this.fromSectionName = componentCheck;
    this.editTagsImageLink = imageLink;
    this.editTagsImageFormats = imgFormat;
    this.editTagsError = "";
    this.assetCurrentId = assetId;
    this.assetCurrentName = currentName;
    this.assetBoardId = boardId;
    this.assetEditTagsStyle = "block";
  }

  closeEditTagsDialog() {
    this.assetEditTagsStyle = "none";
  }

  onSubmitMultipleTags() {
    if(this.tagsForm.valid) {
      this.editTagsList.push(this.tagsForm.value['edittags']);
      this.tagsForm.reset();
    }
  }

  removeAddedTags(index: number) {
    this.editTagsList.splice(index, 1);
  }

  editMultipleTags() {
    this.editTagsError = "";
    if (this.editTagsList.length === 0) {
      this.editTagsError = "Add a tag and press Enter.";
    } else {
      this.showEditTagsLoader = true;
      this.damService.addMultipleImageTags(this.workspaceId, this.assetBoardId, this.assetCurrentId,
        this.editTagsList.join(', ')).subscribe((data: any) => {
          this.editTagsList = [];
          this.showEditTagsLoader = false;
          this.assetEditTagsStyle = "none";
          this.editTagsImageLink = "";
          this.editTagsImageFormats = "";
          this.sendSuccessful = true;
          this.successfullMessage = "Tags added successfully!!"
          this.hideSuccesfullFunction();
          if(this.fromSectionName == 'nested') {
            this.showtableViewData = false;
            this.showNestedViewData = true;
            this.isTableSelected = false;
            this.isNestedSelected = true;
            this.boardImagesSection = true;
            this.searchImageslistSection = false;
            this.getImagesList(this.assetBoardId);
          } else if(this.fromSectionName == 'table') {
            this.showtableViewData = true;
            this.showNestedViewData = false;
            this.isTableSelected = true;
            this.isNestedSelected = false;
            this.boardImagesSection = true;
            this.searchImageslistSection = false;
            this.getImagesList(this.assetBoardId);
          } else if(this.fromSectionName == 'search') {
            this.searchArrayImages(this.searchText, this.searchTerms);
          }
      },
      (error: any) => {
        if(error.status == 403 || error.status == 400){
          this.showEditTagsLoader = false;
          this.editTagsError = error.error.message;
        } else {
          this.showEditTagsLoader = false;
          this.editTagsError = error.error.message;
        }
      });
    }
  }

  showAllImagesView() {
    this.showtableViewData = false;
    this.showNestedViewData = true;
    this.isTableSelected = false;
    this.isNestedSelected = true;
    this.isKanbanSelected = false;
    this.showKanbanView = false;
  }

  showTableListView() {
    this.showtableViewData = true;
    this.showNestedViewData = false;
    this.isTableSelected = true;
    this.isNestedSelected = false;
    this.isKanbanSelected = false;
    this.showKanbanView = false;
  }

  showKanbanViewSelected() {
    this.showtableViewData = false;
    this.showNestedViewData = false;
    this.isTableSelected = false;
    this.isNestedSelected = false;
    this.isKanbanSelected = true;
    this.showKanbanView = true;
  }

  mainDialogColor: string = '#000000E6';

  changeMainDialogColor() {
    this.mainDialogColor = this.mainDialogColor === '#000000E6' ? '#e4e4e4' : '#000000E6';
  }

  restoreAssets(boardId: any, imgId: any) {
    this.damService.restoreAssets(this.workspaceId, boardId, imgId).subscribe((data: any) => {
      this.searchArrayImages(this.searchText, this.searchTerms);
      this.sendSuccessful = true;
      this.successfullMessage = data.message;
      this.hideSuccesfullFunction();
    });
  }

  openEditBoardNames(boardId: any, boardTitle: any) {
    this.renameErrorMsg = "";
    this.boardCurrentName = boardTitle;
    this.editNameBoardId = boardId;
    this.boardNewName = boardTitle;
    this.boardRenameStyle = "block";
  }

  closeEditBoardNames() {
    this.renameErrorMsg = "";
    this.boardRenameStyle = "none";
  }

  editBoardNamesApi(){
    this.renameErrorMsg = "";
    this.showRenameLoader = true;
    this.damService.editBoardName(this.workspaceId, this.editNameBoardId, this.boardNewName).subscribe((data: any) => {
      // this.boardHeading = data.title;
      this.damService.getBoardsList(this.workspaceId).subscribe((data: any) => {
        this.boardRenameStyle = "none";
        this.showRenameLoader = false;
        this.boards = data;
        this.boardname = '';
        this.sendSuccessful = true;
        this.boardHeading = this.boardNewName;
        this.successfullMessage = "Renamed " + this.boardCurrentName + " to " +this.boardNewName;
        this.hideSuccesfullFunction();
        this.getImagesList(this.boardId);
      });
    },(error: any) => {
      if(error.status == 400){
        this.showRenameLoader = false;
        this.renameErrorMsg = error.error.message;
      } else {
        this.showRenameLoader = false;
        this.renameErrorMsg = error.error.message;
      }
   });
  }

  goToLibrary() {
    this.googleAnalyticsService.event('library_click_boards_screen_click', 'library_click', this.currentUser.firstName +" "+this.currentUser.lastName);
    this.router.navigate(['/library']);
  }

  createWorkspace(workspaceName: any){
    if (this.currentUser) {
      if(this.creatwWorkspace.valid) {
        this.showLeaveLoader = true;
        this.isShowCreateWorkspaceError = false
        this.organisationService.createNewWorkspace(workspaceName).subscribe((data: any) => {
          this.showLeaveLoader = false;
          this.creatwWorkspace.reset();
          localStorage.setItem('workspaceDetails', JSON.stringify({ workspaceId: data.id,
            workspaceName: data.title, userRole: data.role }));
          this.router.navigate(['/dam']);
          this.closeNewWorkspaceDialog();
        },
        (error) => {
          if(error.status == 403){
            this.showLeaveLoader = false;
            this.isShowCreateWorkspaceError = true
            this.createWorkspaceErrorMessage = error.error.Message;
          } else {
            this.showLeaveLoader = false;
            this.isShowCreateWorkspaceError = true
            this.createWorkspaceErrorMessage = error.error.Message;
          }
       });
      }
    }else{
      this.isShowCreateLoginWorkspaceError = true
      this.createWorkspaceLoginErrorMessage = "Login to Continue";
    }
  }

  openNewWorkspaceDialog() {
    this.createWorkspaceStyle = "block";
  }

  closeNewWorkspaceDialog() {
    this.createWorkspaceStyle = "none";
  }

  getSuggestedTags(boardId: any, imgId: any){
    this.damService.listGetSuggestedTags(this.workspaceId, boardId, imgId).subscribe((data: any) => {
      this.suggestedTags = data.labels;
    },
    (error) => {
      if(error.status == 400){

      } else {

      }
    });
  }

  editImageName(boardId: any){
    this.renameErrorMsg = "";
    this.imageNameEdit = this.imageHeading;
    this.editImageNameBoardId = boardId;
    this.showEditImageName = true;
    this.hideEditImageName = false;
    this.showEditFavImageName = false;
    this.hideEditFavImageName = false;
  }

  closeImageEditField(){
    this.renameErrorMsg = "";
    this.favImageNameEdit = "";
    this.imageNameEdit = "";
    this.editImageNameBoardId = '';
    this.editImageNameBoardId = '';
    this.showEditImageName = false;
    this.hideEditImageName = true;
    this.showEditFavImageName = false;
    this.hideEditFavImageName = true;
  }

  editImageNameApi(imgId: any, imgFrom: any){
    this.damService.changeImageNameApi(this.workspaceId, this.editImageNameBoardId, imgId, this.imageNameEdit).subscribe((data: any) => {
      this.showEditImageName = false;
      this.hideEditImageName = true;
      this.imageHeading = data.title;
      this.showEditFavImageName = false;
      this.renameErrorMsg = "";
      this.hideEditFavImageName = true;
      if(imgFrom == 'regularDialog') {
        this.uploadService.getFiles(this.workspaceId, this.editImageNameBoardId).subscribe((data: any) => {
          this.fileInfos = data['results'];
          this.boardImagesSection = true;
          this.searchImageslistSection = false;
          for(var i = 0 ; i < this.fileInfos.length ; i++) {
            this.currentIllus = this.fileInfos[this.currentIllusPosition];
          }
          this.showTopRightLoader = false;
        });
      } else if(imgFrom == 'searchDialog') {
        this.damService.searchImagesArray(this.workspaceId, this.searchTerms).subscribe((data: any) => {
          this.searchText = "";
          this.imagesList = data.image;
          this.searchData = '' + this.searchTextSet;
          this.boardImagesSection = false;
          this.searchImageslistSection = true;
          for(var i = 0 ; i < this.imagesList.length ; i++) {
            this.currentIllus = this.imagesList[this.currentSearchIllusPosition];
          }
        });
      }

      this.editImageNameBoardId = "";
    },
    (error: any) => {
      if(error.status == 403){
        this.renameErrorMsg = error.error.message;
      } else {
        this.renameErrorMsg = error.error.message;
      }
   });
  }

  editFavImageName(boardId: any){
    this.renameErrorMsg = "";
    this.favImageNameEdit = this.favImageHeading;
    this.editImageNameBoardId = boardId;
    this.showEditFavImageName = true;
    this.hideEditFavImageName = false;
    this.showEditImageName = false;
    this.hideEditImageName = false;
  }

  editFavImageNameApi(imgId: any, imgFrom: any){
    this.damService.changeImageNameApi(this.workspaceId, this.editImageNameBoardId, imgId, this.favImageNameEdit).subscribe((data: any) => {
      this.showEditFavImageName = false;
      this.hideEditFavImageName = true;
      this.favImageHeading = data.title;
      this.showEditImageName = false;
      this.renameErrorMsg = "";
      this.hideEditImageName = true;
      if(imgFrom == 'regularDialog') {
        this.uploadService.getFiles(this.workspaceId, this.editImageNameBoardId).subscribe((data: any) => {
          this.fileInfos = data['results'];
          this.boardImagesSection = true;
          this.searchImageslistSection = false;
          for(var i = 0 ; i < this.fileInfos.length ; i++) {
            this.currentIllus = this.fileInfos[this.currentIllusPosition];
          }
          this.showTopRightLoader = false;
        });
      } else if(imgFrom == 'searchDialog') {
        this.damService.searchImagesArray(this.workspaceId, this.searchTerms).subscribe((data: any) => {
          this.searchText = "";
          this.imagesList = data.image;
          this.searchData = '' + this.searchTextSet;
          this.boardImagesSection = false;
          this.searchImageslistSection = true;
          for(var i = 0 ; i < this.imagesList.length ; i++) {
            this.currentIllus = this.imagesList[this.currentSearchIllusPosition];
          }
        });
      }
      this.editImageNameBoardId = "";
    },
    (error: any) => {
      if(error.status == 403){
        this.renameErrorMsg = error.error.message;
      } else {
        this.renameErrorMsg = error.error.message;
      }
   });
  }

  goProClick() {
    this.router.navigate(['/dam/subscription']);
  }

  favouriteImagesList = [];

  getFavImagesList() {
    this.damService.listFavouriteImages(this.workspaceId).subscribe((data: any) => {
      this.favouriteImagesList = data['results'];
    });
  }

  selectedSize: string;

  onSizeChange(event: any): void {
    this.selectedSize = event.target.value;
    localStorage.setItem('imageSize', this.selectedSize);
  }
}
